// Beyond Design Custom JavaScript
// All custom section JavaScript should be added here as IIFE functions

(function() {
  'use strict';

  var headerButtonsDrawerExternalOpenUntil = 0;

  // Drag and wheel support for UGC story modals (.bd-collection-ugc-story-modal__track)
  function initUgcStoryModalDragWheel(track, goPrev, goNext) {
    if (!track || typeof goPrev !== 'function' || typeof goNext !== 'function') return;
    var dragStartX = 0;
    var dragStartY = 0;
    var DRAG_THRESHOLD = 50;

    track.addEventListener('mousedown', function(e) {
        e.preventDefault();
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        var onMouseUp = function(upE) {
        var dx = upE.clientX - dragStartX;
        if (Math.abs(dx) > DRAG_THRESHOLD) {
          if (dx > 0) goPrev();
          else goNext();
        }
        document.removeEventListener('mouseup', onMouseUp);
      };
      document.addEventListener('mouseup', onMouseUp);
    });

    track.addEventListener('touchstart', function(e) {
      if (e.touches.length) {
        dragStartX = e.touches[0].clientX;
        dragStartY = e.touches[0].clientY;
      }
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      if (e.changedTouches && e.changedTouches.length) {
        var touch = e.changedTouches[0];
        var dx = touch.clientX - dragStartX;
        if (Math.abs(dx) > DRAG_THRESHOLD) {
          if (dx > 0) goPrev();
          else goNext();
        }
      }
    }, { passive: true });

    track.addEventListener('wheel', function(e) {
      var dx = e.deltaX;
      var dy = e.deltaY;
      if (Math.abs(dx) > Math.abs(dy)) {
        if (dx > 10) { goPrev(); e.preventDefault(); }
        else if (dx < -10) { goNext(); e.preventDefault(); }
      } else if (Math.abs(dy) > 10) {
        if (dy > 0) { goNext(); e.preventDefault(); }
        else { goPrev(); e.preventDefault(); }
      }
    }, { passive: false });
  }

  // Story modal videos sit in [hidden] dialogs, so browsers often skip HTML preload.
  // Warm them after page load, and avoid video.load() on every slide (it restarts download).
  function getStoryModalVideoSrc(video) {
    if (!video) return '';
    if (video.currentSrc) return video.currentSrc;
    if (video.getAttribute('src')) return video.getAttribute('src');
    var source = video.querySelector('source[src]');
    return source ? source.getAttribute('src') : '';
  }

  function warmStoryModalVideo(video) {
    if (!video || video.dataset.bdStoryWarmed === '1') return;
    video.dataset.bdStoryWarmed = '1';
    video.muted = true;
    video.preload = 'auto';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    try {
      if (video.readyState < 2) video.load();
    } catch (err) {}

    var url = getStoryModalVideoSrc(video);
    if (!url || typeof fetch !== 'function') return;
    // Warm HTTP cache (hidden <video preload> is unreliable). Read ~0.75MB then cancel.
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'force-cache',
      signal: controller ? controller.signal : undefined
    }).then(function(res) {
      if (!res || !res.ok || !res.body || !res.body.getReader) return;
      var reader = res.body.getReader();
      var received = 0;
      var MAX_BYTES = 750000;
      function pump() {
        return reader.read().then(function(result) {
          if (result.done) return;
          received += (result.value && result.value.byteLength) || 0;
          if (received >= MAX_BYTES) {
            try { reader.cancel(); } catch (e) {}
            if (controller) controller.abort();
            return;
          }
          return pump();
        });
      }
      return pump();
    }).catch(function() {
      // CORS fallback: opaque request may still help cache in some browsers
      fetch(url, { mode: 'no-cors', credentials: 'omit', cache: 'force-cache' }).catch(function() {});
    });
  }

  function scheduleStoryModalVideoWarmup(root) {
    if (!root) return;
    var videos = Array.prototype.slice.call(root.querySelectorAll('.bd-collection-ugc-story-modal__video'));
    if (!videos.length) return;

    var index = 0;
    var active = 0;
    var CONCURRENCY = 2;

    function startNext() {
      while (active < CONCURRENCY && index < videos.length) {
        (function(video) {
          active++;
          warmStoryModalVideo(video);
          setTimeout(function() {
            active--;
            startNext();
          }, 450);
        })(videos[index++]);
      }
    }

    function begin() {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(function() { startNext(); }, { timeout: 2500 });
      } else {
        setTimeout(startNext, 1000);
      }
    }

    if (document.readyState === 'complete') begin();
    else window.addEventListener('load', begin, { once: true });
  }

  function prefetchAdjacentStoryVideos(slides, activeIndex) {
    if (!slides || !slides.length) return;
    [activeIndex + 1, activeIndex - 1, activeIndex + 2].forEach(function(i) {
      if (i < 0 || i >= slides.length) return;
      var video = slides[i].querySelector('.bd-collection-ugc-story-modal__video');
      if (video) warmStoryModalVideo(video);
    });
  }

  function playStoryModalVideo(video, onFail, withSound) {
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (err) {}
    if (withSound) {
      video.muted = false;
      video.removeAttribute('muted');
    } else {
      video.muted = true;
      video.setAttribute('muted', '');
    }
    video.preload = 'auto';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var settled = false;
    var tryPlay = function() {
      if (settled) return;
      settled = true;
      video.removeEventListener('canplay', onReady);
      video.removeEventListener('loadeddata', onReady);
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.catch(function() {
          // If unmuted play is blocked, fall back to muted so the story still advances.
          if (withSound && video.muted === false) {
            video.muted = true;
            video.setAttribute('muted', '');
            var retry = video.play();
            if (retry && typeof retry.then === 'function') {
              retry.catch(function() {
                if (typeof onFail === 'function') onFail();
              });
              return;
            }
          }
          if (typeof onFail === 'function') onFail();
        });
      }
    };

    var onReady = function() { tryPlay(); };

    // Already buffered from page-load warmup — play immediately (do not call load()).
    if (video.readyState >= 2) {
      tryPlay();
      return;
    }

    video.addEventListener('canplay', onReady);
    video.addEventListener('loadeddata', onReady);
    warmStoryModalVideo(video);
    if (video.readyState === 0) {
      try { video.load(); } catch (err) {}
    }
    setTimeout(function() {
      if (video.readyState >= 2) tryPlay();
    }, 80);
  }

  // Product card color swatches: mobile prev/next scroll (3 visible, scroll by 3)
  function initProductCardSwatchNav() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__swatch-nav');
      if (!btn) return;
      var wrapper = btn.closest('.product-card__swatch-list-wrapper');
      if (!wrapper || !wrapper.classList.contains('product-card__swatch-list-wrapper--scrollable')) return;
      var fieldset = wrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
      if (!fieldset) return;
      var isNext = btn.classList.contains('product-card__swatch-nav--next');
      var scrollAmount = 110;
      if (typeof window.getComputedStyle !== 'undefined') {
        var gap = parseFloat(window.getComputedStyle(fieldset).gap) || 12.8;
        var first = fieldset.querySelector('.card__color-swatch-btn, .swatch');
        var itemWidth = first ? first.offsetWidth + gap : 37;
        scrollAmount = Math.round(itemWidth * 3);
      }
      fieldset.scrollBy({ left: isNext ? scrollAmount : -scrollAmount, behavior: 'smooth' });
    });
  }

  // Initialize all custom sections when DOM is ready
  function initCustomSections() {
    initProductCardSwatchNav();
    // Featured Collection Slider
    initFeaturedCollectionSliders();
    
    // Split Content Product
    initSplitContentProducts();
    initSplitContentImageSwatches();
    
    // Product Series
    initProductSeries();
    
    // Split Content Video
    initSplitContentVideos();
    initSplitContentImageVideos();
    
    // Find The Series
    initFindTheSeries();
    initRealSpaces();
    
    // Featured Product Slider
    initFeaturedProductSliders();
    
    // Featured Products
    initFeaturedProducts();
    
    // FAQ
    initFAQ();
    
    // Features List
    initFeaturesList();
    
    // Build Your Sofa
    initBuildYourSofa();

    // Footer Collapsible Menus
    initFooterCollapsible();
    
    // Mega Menu Dynamic Switching
    initMegaMenu();
    
    // Menu Drawer Category Sliders
    initMenuDrawerCategorySliders();

  // Header Buttons Drawer
  initHeaderButtonsDrawer();
  initHeaderButtonsDrawerExternalTriggers();

  // Header search (predictive search): add header--mega-menu-open when search modal is open
  initHeaderSearchMegaMenuClass();

  // Product card color swatches: update card image when swatch is clicked
  initProductCardSwatches();

  // Product card option switchers: cycle next value and update card image
  initProductCardOptionSwitchers();

  // Sync available options on load (show/hide swatches and limit switchers by variant availability)
  // Also re-run after AJAX collection filters / load-more (via window.syncProductCardAvailableOptions)
  (function runSyncAvailableOptionsOnCards() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        if (typeof window.syncProductCardAvailableOptions === 'function') {
          window.syncProductCardAvailableOptions();
        }
      });
    } else if (typeof window.syncProductCardAvailableOptions === 'function') {
      window.syncProductCardAvailableOptions();
    }
  })();

  // Product card Material/Ausrichtung: cycle to next product and update card
  // Collection UGC slider (above product grid)
  initCollectionUgcSliders();
  }

  // Featured Collection Slider – init as soon as Swiper is ready (short retry for fast appearance)
  function initFeaturedCollectionSliders() {
    const sections = document.querySelectorAll('.bd-featured-collection-slider[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const swiperElement = document.getElementById('bd-featured-collection-swiper-' + sectionId);
      if (!swiperElement) return;
      
      const loop = section.dataset.loop === 'true';
      const autoplay = section.dataset.autoplay === 'true';
      const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 3000;
      const slidesPerViewMobile = parseFloat(section.dataset.slidesPerViewMobile) || 2.5;
      const slidesPerViewTablet = parseFloat(section.dataset.slidesPerViewTablet) || 4;
      const slidesPerViewDesktop = parseFloat(section.dataset.slidesPerViewDesktop) || 6;
      const spaceBetweenMobile = parseInt(section.dataset.spaceBetweenMobile) || 4;
      const spaceBetween = parseInt(section.dataset.spaceBetween) || 20;
      const disableCentered = section.dataset.disableCentered === 'true';
      
      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          requestAnimationFrame(initSwiper);
          return;
        }

        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }

        const breakpointCenteredSlides = !disableCentered;

        new Swiper(swiperElement, {
          loop: loop,
          mousewheel: {
              forceToAxis: true, // Ignores vertical (y-axis) scrolling
          },
          centeredSlides: false,
          autoplay: autoplay ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          } : false,
          slidesPerView: slidesPerViewMobile,
          spaceBetween: spaceBetweenMobile,
          breakpoints: {
            640: {
              slidesPerView: slidesPerViewTablet,
              spaceBetween: spaceBetween,
              centeredSlides: breakpointCenteredSlides,
            },
            750: {
              centeredSlides: breakpointCenteredSlides,
            },
            990: {
              slidesPerView: slidesPerViewDesktop,
              spaceBetween: spaceBetween,
              centeredSlides: breakpointCenteredSlides,
            },
          },
        });
      }

      initSwiper();
    });
  }

  // Split Content Product
  function initSplitContentProducts() {
    const sections = document.querySelectorAll('.bd-split-content-product[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const swiperElement = document.getElementById('bd-split-content-product-swiper-' + sectionId);
      if (!swiperElement) return;
      
      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }
        const swiper = new Swiper(swiperElement, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
        });

        // Handle color swatch clicks
        const swatches = section.querySelectorAll('.bd-split-content-product__swatch[data-slide-index]');
        const slides = swiperElement.querySelectorAll('.swiper-slide');
        
        swatches.forEach(function(swatch) {
          swatch.addEventListener('click', function() {
            const slideIndex = parseInt(this.dataset.slideIndex);
            if (slideIndex >= 0 && slideIndex < slides.length) {
              swiper.slideTo(slideIndex);
              
              // Update active state
              swatches.forEach(function(s) {
                s.classList.remove('bd-split-content-product__swatch--active');
                const existingCheck = s.querySelector('.bd-split-content-product__swatch-check');
                if (existingCheck) existingCheck.remove();
              });
              this.classList.add('bd-split-content-product__swatch--active');
              
              // Add checkmark to active swatch
              if (!this.querySelector('.bd-split-content-product__swatch-check')) {
                const check = document.createElement('span');
                check.className = 'bd-split-content-product__swatch-check';
                check.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="#FDFCFB" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                this.appendChild(check);
              }
            }
          });
        });

        // Update active swatch when slide changes
        swiper.on('slideChange', function() {
          const activeIndex = swiper.activeIndex;
          const activeSlide = slides[activeIndex];
          if (activeSlide) {
            swatches.forEach(function(s) {
              const slideIndex = parseInt(s.dataset.slideIndex);
              
              s.classList.remove('bd-split-content-product__swatch--active');
              const existingCheck = s.querySelector('.bd-split-content-product__swatch-check');
              if (existingCheck) existingCheck.remove();
              
              if (slideIndex === activeIndex) {
                s.classList.add('bd-split-content-product__swatch--active');
                const check = document.createElement('span');
                check.className = 'bd-split-content-product__swatch-check';
                check.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="#FDFCFB" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                s.appendChild(check);
              }
            });
          }
        });
      }
      
      initSwiper();
    });
  }

  // Split Content Image - Product Swatches
  function initSplitContentImageSwatches() {
    const sections = document.querySelectorAll('.bd-texture-color[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const swiperElement = document.getElementById('bd-texture-color-swiper-' + sectionId);
      if (!swiperElement) return;
      
      const block = swiperElement.closest('.bd-texture-color__block--product-swatches');
      if (!block) return;
      
      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }
        const swiper = new Swiper(swiperElement, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: true,
        });

        // Handle color swatch clicks
        const swatches = block.querySelectorAll('.bd-texture-color__swatch[data-slide-index]');
        const slides = swiperElement.querySelectorAll('.swiper-slide');
        
        swatches.forEach(function(swatch) {
          swatch.addEventListener('click', function() {
            const slideIndex = parseInt(this.dataset.slideIndex);
            if (slideIndex >= 0 && slideIndex < slides.length) {
              swiper.slideTo(slideIndex);
              
              // Update active state
              swatches.forEach(function(s) {
                s.classList.remove('bd-texture-color__swatch--active');
                const existingCheck = s.querySelector('.bd-texture-color__swatch-check');
                if (existingCheck) existingCheck.remove();
              });
              this.classList.add('bd-texture-color__swatch--active');
              
              // Add checkmark to active swatch
              if (!this.querySelector('.bd-texture-color__swatch-check')) {
                const check = document.createElement('span');
                check.className = 'bd-texture-color__swatch-check';
                check.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="#FDFCFB" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                this.appendChild(check);
              }
            }
          });
        });

        // Update active swatch when slide changes
        swiper.on('slideChange', function() {
          const activeIndex = swiper.activeIndex;
          const activeSlide = slides[activeIndex];
          if (activeSlide) {
            swatches.forEach(function(s) {
              const slideIndex = parseInt(s.dataset.slideIndex);
              
              s.classList.remove('bd-texture-color__swatch--active');
              const existingCheck = s.querySelector('.bd-texture-color__swatch-check');
              if (existingCheck) existingCheck.remove();
              
              if (slideIndex === activeIndex) {
                s.classList.add('bd-texture-color__swatch--active');
                const check = document.createElement('span');
                check.className = 'bd-texture-color__swatch-check';
                check.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="#FDFCFB" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                s.appendChild(check);
              }
            });
          }
        });
      }
      
      initSwiper();
    });
  }

  // Product Series
  function initProductSeries() {
    const sections = document.querySelectorAll('.bd-product-series[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const titles = section.querySelectorAll('.bd-product-series__title');
      const mainHeading = section.querySelector('#bd-product-series-heading-' + sectionId);
      const imageContainer = section.querySelector('.bd-product-series__image-container');
      const productWrappers = section.querySelectorAll('.bd-product-series__products-wrapper');
      
      if (!titles.length || !mainHeading || !imageContainer) return;
      
      // Initialize product sliders for all blocks
      productWrappers.forEach(function(wrapper) {
        const blockId = wrapper.dataset.blockId;
        const swiperElement = document.getElementById('bd-product-series-swiper-' + sectionId + '-' + blockId);
        if (!swiperElement) return;
        
        const loop = wrapper.dataset.loop === 'true';
        const autoplay = wrapper.dataset.autoplay === 'true';
        const autoplayDelay = parseInt(wrapper.dataset.autoplayDelay) || 3000;
        const slidesPerViewMobile = parseFloat(wrapper.dataset.slidesPerViewMobile) || 2.5;
        const slidesPerViewTablet = parseFloat(wrapper.dataset.slidesPerViewTablet) || 4;
        const slidesPerViewDesktop = parseFloat(wrapper.dataset.slidesPerViewDesktop) || 3;
        const spaceBetween = parseInt(wrapper.dataset.spaceBetween) || 20;
        const isActive = wrapper.classList.contains('bd-product-series__products-wrapper--active');
        
        function initSwiper() {
          if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
            return;
          }
          if (swiperElement.swiper) {
            swiperElement.swiper.destroy(true, true);
          }

          // If wrapper is hidden, wait until it's shown before initializing
          if (!isActive) {
            // Store config for later initialization
            wrapper.swiperConfig = {
              loop: loop,
              autoplay: autoplay,
              autoplayDelay: autoplayDelay,
              slidesPerViewMobile: slidesPerViewMobile,
              slidesPerViewTablet: slidesPerViewTablet,
              slidesPerViewDesktop: slidesPerViewDesktop,
              spaceBetween: spaceBetween
            };
            return;
          }

          const swiper = new Swiper(swiperElement, {
            loop: loop,
            mousewheel: {
              forceToAxis: true, // Ignores vertical (y-axis) scrolling
            },
            centeredSlides: true, // Center slides on mobile
            autoplay: autoplay ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
            } : false,
            slidesPerView: slidesPerViewMobile,
            spaceBetween: spaceBetween,
            initialSlide: 0, // Start from first slide on mobile
            breakpoints: {
              640: {
                slidesPerView: slidesPerViewTablet,
                spaceBetween: spaceBetween,
                centeredSlides: false,
                initialSlide: 1,
              },
              990: {
                slidesPerView: 3, // Show 3 slides to achieve half + 2 full + half
                spaceBetween: spaceBetween,
                centeredSlides: false,
                initialSlide: 1,
              },
            },
            on: {
              init: function() {
                // Use Swiper API to position slides: half + 2 full + half layout
                if (window.innerWidth >= 990 && slidesPerViewDesktop === 3) {
                  setTimeout(function() {
                    // Get current translate value
                    const currentTranslate = swiper.getTranslate();
                    // Calculate slide width including space between
                    const containerWidth = swiperElement.offsetWidth;
                    const slideWidth = (containerWidth - (spaceBetween * 2)) / 3;
                    // Offset by half slide width to show half of previous slide
                    const halfSlideOffset = slideWidth / 2;
                    // Set new translate position
                    swiper.setTranslate(currentTranslate - halfSlideOffset);
                  }, 100);
                }
              },
              resize: function() {
                // Recalculate on resize
                if (window.innerWidth >= 990 && slidesPerViewDesktop === 3) {
                  setTimeout(function() {
                    const currentTranslate = swiper.getTranslate();
                    const containerWidth = swiperElement.offsetWidth;
                    const slideWidth = (containerWidth - (spaceBetween * 2)) / 3;
                    const halfSlideOffset = slideWidth / 2;
                    swiper.setTranslate(currentTranslate - halfSlideOffset);
                  }, 100);
                }
              }
            }
          });
          
          // Store swiper instance on wrapper for later access
          wrapper.swiperInstance = swiper;
        }
        
        initSwiper();
      });
      
      // Set initial active state
      const firstTitle = titles[0];
      if (firstTitle) {
        firstTitle.classList.add('bd-product-series__title--active');
        const blockId = firstTitle.dataset.blockId;
        if (blockId) {
          const imageWrapper = imageContainer.querySelector(`[data-block-id="${blockId}"]`);
          if (imageWrapper) {
            imageWrapper.classList.add('bd-product-series__image-wrapper--active');
            mainHeading.textContent = firstTitle.textContent.trim();
          }
          
          // Show first product slider if it exists
          const firstProductWrapper = section.querySelector(`.bd-product-series__products-wrapper[data-block-id="${blockId}"]`);
          if (firstProductWrapper) {
            firstProductWrapper.classList.add('bd-product-series__products-wrapper--active');
          }
        }
      }
      
      // Handle title clicks
      titles.forEach(function(title) {
        title.addEventListener('click', function() {
          const blockId = this.dataset.blockId;
          if (!blockId) return;
          
          // Update active title
          titles.forEach(function(t) {
            t.classList.remove('bd-product-series__title--active');
          });
          this.classList.add('bd-product-series__title--active');
          
          // Update active image
          const imageWrappers = imageContainer.querySelectorAll('.bd-product-series__image-wrapper');
          imageWrappers.forEach(function(wrapper) {
            wrapper.classList.remove('bd-product-series__image-wrapper--active');
          });
          
          const targetWrapper = imageContainer.querySelector(`[data-block-id="${blockId}"]`);
          if (targetWrapper) {
            targetWrapper.classList.add('bd-product-series__image-wrapper--active');
            mainHeading.textContent = this.textContent.trim();
          }
          
          // Update active product slider
          productWrappers.forEach(function(wrapper) {
            wrapper.classList.remove('bd-product-series__products-wrapper--active');
          });
          
          const targetProductWrapper = section.querySelector(`.bd-product-series__products-wrapper[data-block-id="${blockId}"]`);
          if (targetProductWrapper) {
            targetProductWrapper.classList.add('bd-product-series__products-wrapper--active');
            
            // Initialize swiper if it hasn't been initialized yet
            if (!targetProductWrapper.swiperInstance && targetProductWrapper.swiperConfig) {
              const config = targetProductWrapper.swiperConfig;
              const swiperElement = document.getElementById('bd-product-series-swiper-' + sectionId + '-' + blockId);
              
              if (swiperElement && typeof Swiper !== 'undefined') {
                const swiper = new Swiper(swiperElement, {
                  loop: config.loop,
                  centeredSlides: true, // Center slides on mobile
                  autoplay: config.autoplay ? {
                    delay: config.autoplayDelay,
                    disableOnInteraction: false,
                  } : false,
                  slidesPerView: config.slidesPerViewMobile,
                  spaceBetween: config.spaceBetween,
                  initialSlide: 0, // Start from first slide on mobile
                  breakpoints: {
                    640: {
                      slidesPerView: config.slidesPerViewTablet,
                      spaceBetween: config.spaceBetween,
                      centeredSlides: false,
                      initialSlide: 1,
                    },
                    990: {
                      slidesPerView: 3, // Show 3 slides to achieve half + 2 full + half
                      spaceBetween: config.spaceBetween,
                      centeredSlides: false,
                      initialSlide: 1,
                    },
                  },
                  on: {
                    init: function() {
                      // Use Swiper API to position slides: half + 2 full + half layout
                      if (window.innerWidth >= 990 && config.slidesPerViewDesktop === 3) {
                        setTimeout(function() {
                          // Get current translate value using Swiper API
                          const currentTranslate = swiper.getTranslate();
                          // Calculate slide width including space between
                          const containerWidth = swiperElement.offsetWidth;
                          const slideWidth = (containerWidth - (config.spaceBetween * 2)) / 3;
                          // Offset by half slide width to show half of previous slide
                          const halfSlideOffset = slideWidth / 2;
                          // Set new translate position using Swiper API
                          swiper.setTranslate(currentTranslate - halfSlideOffset);
                        }, 100);
                      }
                    },
                    resize: function() {
                      // Recalculate on resize
                      if (window.innerWidth >= 990 && config.slidesPerViewDesktop === 3) {
                        setTimeout(function() {
                          const currentTranslate = swiper.getTranslate();
                          const containerWidth = swiperElement.offsetWidth;
                          const slideWidth = (containerWidth - (config.spaceBetween * 2)) / 3;
                          const halfSlideOffset = slideWidth / 2;
                          swiper.setTranslate(currentTranslate - halfSlideOffset);
                        }, 100);
                      }
                    }
                  }
                });
                
                targetProductWrapper.swiperInstance = swiper;
                delete targetProductWrapper.swiperConfig;
              }
            }
            
            // Update swiper if it exists - need to recalculate after showing
            if (targetProductWrapper.swiperInstance) {
              const swiper = targetProductWrapper.swiperInstance;
              const swiperElement = swiper.el;
              const slidesPerViewDesktop = parseFloat(targetProductWrapper.dataset.slidesPerViewDesktop) || 3;
              const spaceBetween = parseInt(targetProductWrapper.dataset.spaceBetween) || 20;
              
              // Wait for display change, then update swiper dimensions using Swiper API
              setTimeout(function() {
                // Use Swiper API methods to update dimensions
                swiper.updateSize();
                swiper.updateSlides();
                swiper.update();
                
                // Reset slide position based on screen size
                if (window.innerWidth < 640) {
                  // Mobile: center slides, go to first slide
                  swiper.slideTo(0, 0);
                } else {
                  // Tablet/Desktop: go to 2nd slide (index 1)
                  swiper.slideTo(1, 0);
                }
                
                // Reapply half-slide offset on desktop using Swiper API methods
                if (window.innerWidth >= 990 && slidesPerViewDesktop === 3) {
                  setTimeout(function() {
                    // Get current translate using Swiper API
                    const currentTranslate = swiper.getTranslate();
                    // Calculate slide width including space between
                    const containerWidth = swiperElement.offsetWidth;
                    const slideWidth = (containerWidth - (spaceBetween * 2)) / 3;
                    // Offset by half slide width to show half of previous slide
                    const halfSlideOffset = slideWidth / 2;
                    // Set new translate position using Swiper API
                    swiper.setTranslate(currentTranslate - halfSlideOffset);
                  }, 50);
                }
              }, 50);
            }
          }
        });
      });
    });
  }

  // Split Content Video
  function initSplitContentVideos() {
    const sections = document.querySelectorAll('.bd-split-content-video[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const videoWrapper = document.getElementById('bd-video-wrapper-' + sectionId);
      if (!videoWrapper) return;
      
      const playButton = videoWrapper.querySelector('.bd-split-content-video__play-button');
      const videoContainers = videoWrapper.querySelectorAll('.bd-split-content-video__video-container');
      const iframe = videoWrapper.querySelector('.bd-split-content-video__iframe');
      const poster = videoWrapper.querySelector('.bd-split-content-video__poster');
      
      // Ensure video containers are hidden on page load
      videoContainers.forEach(function(container) {
        container.style.display = 'none';
        const videoElement = container.querySelector('video');
        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0;
          videoElement.removeAttribute('autoplay');
        }
      });
      
      if (!playButton) return;
      
      playButton.addEventListener('click', function() {
        const videoType = this.getAttribute('data-video-type');
        
        if (videoType === 'url' && videoContainers[0] && iframe) {
          const videoUrl = this.getAttribute('data-video-url');
          if (!videoUrl) return;
          
          // Convert YouTube/Vimeo URLs to embed format
          let embedUrl = videoUrl;
          if (videoUrl.includes('youtube.com/watch') || videoUrl.includes('youtu.be/')) {
            const videoId = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)?.[1];
            if (videoId) {
              embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            }
          } else if (videoUrl.includes('vimeo.com/')) {
            const videoId = videoUrl.match(/vimeo\.com\/(\d+)/)?.[1];
            if (videoId) {
              embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
            }
          }
          
          iframe.src = embedUrl;
          videoContainers[0].style.display = 'block';
          playButton.style.display = 'none';
          if (poster) poster.style.display = 'none';
        } else if (videoType === 'upload' && videoContainers[0]) {
          const videoElement = videoContainers[0].querySelector('video');
          if (videoElement) {
            // Ensure video is paused and reset
            videoElement.pause();
            videoElement.currentTime = 0;
            // Show container and play
            videoContainers[0].style.display = 'block';
            videoElement.play().catch(function(error) {
              console.log('Video play failed:', error);
            });
          }
          playButton.style.display = 'none';
          if (poster) poster.style.display = 'none';
        }
      });
    });
  }

  // Split Content Image – video blocks (click-to-play)
  function getActiveSplitImageVideo(videoContainer) {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const mobileVideo = videoContainer.querySelector('.bd-split-content-image__video-element--mobile');
    const desktopVideo = videoContainer.querySelector('.bd-split-content-image__video-element--desktop');
    const fallbackVideo = videoContainer.querySelector('.bd-split-content-image__video-element:not(.bd-split-content-image__video-element--mobile):not(.bd-split-content-image__video-element--desktop)');

    if (isMobile) {
      return mobileVideo || fallbackVideo || desktopVideo;
    }

    return desktopVideo || fallbackVideo || mobileVideo;
  }

  function ensureSplitImageVideoPlaysInline(videoElement) {
    if (!videoElement) return;
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');
    videoElement.playsInline = true;
  }

  function pauseInactiveSplitImageVideos(wrapper) {
    if (!wrapper) return;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const videos = wrapper.querySelectorAll('.bd-split-content-image__video-element');
    videos.forEach(function(videoElement) {
      ensureSplitImageVideoPlaysInline(videoElement);
      const isMobileVideo = videoElement.classList.contains('bd-split-content-image__video-element--mobile');
      const isDesktopVideo = videoElement.classList.contains('bd-split-content-image__video-element--desktop');
      const isInactive = (isMobile && isDesktopVideo) || (!isMobile && isMobileVideo);
      if (!isInactive) return;
      videoElement.pause();
      videoElement.removeAttribute('autoplay');
      try { videoElement.currentTime = 0; } catch (err) {}
    });
  }

  function playSplitImageVideo(videoElement) {
    if (!videoElement) return;

    ensureSplitImageVideoPlaysInline(videoElement);
    videoContainerPrepare(videoElement);

    const playPromise = videoElement.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function(error) {
        console.log('Video play failed:', error);
      });
    }
  }

  function videoContainerPrepare(videoElement) {
    if (videoElement.readyState === 0) {
      videoElement.load();
    }
  }

  function initSplitContentImageVideos() {
    // Keep autoplay videos inline on iOS and stop the hidden breakpoint video from playing.
    document.querySelectorAll('.bd-split-content-image__video-wrapper').forEach(function(videoWrapper) {
      pauseInactiveSplitImageVideos(videoWrapper);
      videoWrapper.querySelectorAll('video').forEach(ensureSplitImageVideoPlaysInline);
    });

    const videoWrappers = document.querySelectorAll('.bd-split-content-image__video-wrapper[data-click-to-play="true"]');

    videoWrappers.forEach(function(videoWrapper) {
      const playButton = videoWrapper.querySelector('.bd-split-content-image__video-play-button');
      const videoContainer = videoWrapper.querySelector('.bd-split-content-image__video-container');
      const iframe = videoWrapper.querySelector('.bd-split-content-image__video-iframe');
      const posters = videoWrapper.querySelectorAll('.bd-split-content-image__video-poster');

      if (!videoContainer) return;

      videoContainer.style.display = 'none';
      const videoElements = videoContainer.querySelectorAll('video');
      videoElements.forEach(function(videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
        videoElement.removeAttribute('autoplay');
        ensureSplitImageVideoPlaysInline(videoElement);
      });

      if (!playButton) return;

      playButton.addEventListener('click', function() {
        const videoType = this.getAttribute('data-video-type');

        if (videoType === 'url' && iframe) {
          const videoUrl = this.getAttribute('data-video-url');
          if (!videoUrl) return;

          let embedUrl = videoUrl;
          if (videoUrl.includes('youtube.com/watch') || videoUrl.includes('youtu.be/')) {
            const videoId = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)?.[1];
            if (videoId) {
              embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1`;
            }
          } else if (videoUrl.includes('vimeo.com/')) {
            const videoId = videoUrl.match(/vimeo\.com\/(\d+)/)?.[1];
            if (videoId) {
              embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&playsinline=1`;
            }
          }

          videoContainer.style.display = 'block';
          iframe.src = embedUrl;
          playButton.style.display = 'none';
          posters.forEach(function(poster) {
            poster.style.display = 'none';
          });
        } else if (videoType === 'upload') {
          const activeVideo = getActiveSplitImageVideo(videoContainer);

          videoContainer.style.display = 'block';
          pauseInactiveSplitImageVideos(videoWrapper);
          if (activeVideo) {
            activeVideo.pause();
            activeVideo.currentTime = 0;
            playSplitImageVideo(activeVideo);
          }

          playButton.style.display = 'none';
          posters.forEach(function(poster) {
            poster.style.display = 'none';
          });
        }
      });
    });

    if (!window.__bdSplitImageVideoResizeBound) {
      window.__bdSplitImageVideoResizeBound = true;
      var splitImageVideoResizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(splitImageVideoResizeTimer);
        splitImageVideoResizeTimer = setTimeout(function() {
          document.querySelectorAll('.bd-split-content-image__video-wrapper').forEach(pauseInactiveSplitImageVideos);
        }, 150);
      });
    }
  }

  // Featured Product Slider – products from collection metafield, card-product, header like find-the-series
  function initFeaturedProductSliders() {
    const sections = document.querySelectorAll('.bd-featured-product-slider[data-section-id]');
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const swiperElement = document.getElementById('bd-featured-product-swiper-' + sectionId);
      if (!swiperElement) return;

      const centerSlides = section.dataset.centerSlides === 'true';
      const productCount = parseInt(section.dataset.productCount, 10) || 0;
      const shouldLoop = productCount >= 3;
      const slidesPerViewMobile = parseFloat(section.dataset.slidesPerViewMobile) || 1.2;
      const slidesPerViewDesktopSetting = parseFloat(section.dataset.slidesPerViewDesktop) || 4;
      // Fewer than 3 products: keep card width as if 3 are visible (centered / not stretched)
      const slidesPerViewDesktop = productCount > 0 && productCount < 3 ? 3 : slidesPerViewDesktopSetting;
      let slidesGapMobile = 8;
      const gapMobileAttr = section.getAttribute('data-slides-gap-mobile');
      if (gapMobileAttr !== null && gapMobileAttr !== '') {
        const parsed = parseInt(gapMobileAttr, 10);
        if (!isNaN(parsed) && parsed >= 0) slidesGapMobile = parsed;
      }
      const slidesGap = parseInt(section.dataset.slidesGap, 10);
      const desktopGap = !isNaN(slidesGap) && slidesGap >= 0 ? slidesGap : 8;

      const prevButtonSelector = '.bd-featured-product-slider__nav-button--prev';
      const nextButtonSelector = '.bd-featured-product-slider__nav-button--next';

      function getCenterSlidesOffset() {
        var w = swiperElement.offsetWidth;
        return w > 0 ? Math.floor(w / 6) : 0;
      }

      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }
        var offsetPx = getCenterSlidesOffset();
        var baseConfig = {
          loop: shouldLoop,
          loopAdditionalSlides: Math.max(4, Math.ceil(slidesPerViewDesktop * 2)),
          centeredInsufficientSlides: true,
          mousewheel: {
            forceToAxis: true, // Ignores vertical (y-axis) scrolling
          },
          slidesPerView: slidesPerViewMobile,
          spaceBetween: slidesGapMobile,
          breakpoints: {},
        };
        if (centerSlides && shouldLoop && typeof window !== 'undefined' && window.innerWidth >= 750) {
          baseConfig.initialSlide = 1;
        }
        if (centerSlides && shouldLoop) {
          baseConfig.breakpoints[750] = {
            slidesPerView: 3,
            spaceBetween: desktopGap,
            slidesOffsetBefore: offsetPx,
            slidesOffsetAfter: offsetPx,
          };
        } else {
          baseConfig.breakpoints[750] = {
            slidesPerView: slidesPerViewDesktop,
            spaceBetween: desktopGap,
          };
        }
        const swiper = new Swiper(swiperElement, baseConfig);
        const allPrevButtons = section.querySelectorAll(prevButtonSelector);
        const allNextButtons = section.querySelectorAll(nextButtonSelector);
        allPrevButtons.forEach(function(btn) {
          btn.addEventListener('click', function() { swiper.slidePrev(); });
        });
        allNextButtons.forEach(function(btn) {
          btn.addEventListener('click', function() { swiper.slideNext(); });
        });
        function updateButtonStates() {
          allPrevButtons.forEach(function(btn) { btn.disabled = swiper.isBeginning; });
          allNextButtons.forEach(function(btn) { btn.disabled = swiper.isEnd; });
        }
        swiper.on('slideChange', updateButtonStates);
        updateButtonStates();
      }
      initSwiper();
    });
  }

  // Real Spaces – grid of cards, play/pause video; click .bd-real-spaces__block-item opens UGC story modal (except product wrap and social icons)
  function initRealSpaces() {
    const sections = document.querySelectorAll('.bd-real-spaces[data-section-id]');
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const enableVideoSound = section.dataset.enableVideoSound === 'true';
      const panels = section.querySelectorAll('.bd-real-spaces__panel');

      function pauseOtherRealSpacesVideos(exceptVideo) {
        section.querySelectorAll('.bd-real-spaces__video').forEach(function(otherVideo) {
          if (exceptVideo && otherVideo === exceptVideo) return;
          var otherBlock = otherVideo.closest('.bd-real-spaces__block-item');
          var otherPlayButton = otherBlock ? otherBlock.querySelector('.bd-real-spaces__play-button') : null;
          var otherImagesParent = otherBlock ? otherBlock.querySelector('.bd-real-spaces__images-parent') : null;
          var otherPlayIcon = otherPlayButton ? otherPlayButton.querySelector('.bd-real-spaces__play-icon-svg') : null;
          var otherPauseIcon = otherPlayButton ? otherPlayButton.querySelector('.bd-real-spaces__pause-icon-svg') : null;

          if (otherVideo.tagName === 'VIDEO' && !otherVideo.paused) {
            otherVideo.pause();
          }

          if (otherPlayIcon) otherPlayIcon.style.display = 'block';
          if (otherPauseIcon) otherPauseIcon.style.display = 'none';
          if (otherPlayButton) otherPlayButton.setAttribute('aria-label', 'Play video');
          if (otherImagesParent) {
            otherImagesParent.classList.remove('bd-real-spaces__images-parent--video-playing');
          }
        });
      }

      function initPanelStoryModal(panelIndex) {
        const modal = document.getElementById('bd-real-spaces-story-modal-' + sectionId + '-' + panelIndex);
        if (!modal) return;
        const progressSegs = modal.querySelectorAll('.bd-collection-ugc-story-modal__progress-seg');
        const modalSlides = modal.querySelectorAll('.bd-collection-ugc-story-modal__slide');
        const modalCloseBtn = modal.querySelector('.bd-collection-ugc-story-modal__close');
        const modalOverlay = modal.querySelector('.bd-collection-ugc-story-modal__overlay');
        const modalPrevBtn = modal.querySelector('.bd-collection-ugc-story-modal__prev');
        const modalNextBtn = modal.querySelector('.bd-collection-ugc-story-modal__next');
        const modalBlockContents = modal.querySelectorAll('.bd-collection-ugc-story-modal__block-content');
        const modalShowPrevNext = modal.dataset.showPrevNext !== 'false';
        const modalAutoAdvance = modal.dataset.autoAdvance !== 'false';
        const modalEnableVideoSound = enableVideoSound || modal.dataset.enableVideoSound === 'true';
        var currentIndex = 0;
        var advanceTimer = null;

        function pauseAllVideos() {
          modal.querySelectorAll('.bd-collection-ugc-story-modal__video').forEach(function(v) {
            v.pause();
            v.onended = null;
          });
        }

        function updateProgressBars(activeIndex) {
          progressSegs.forEach(function(seg, idx) {
            seg.classList.toggle('bd-collection-ugc-story-modal__progress-seg--active', idx === activeIndex);
            var fill = seg.querySelector('.bd-collection-ugc-story-modal__progress-fill');
            if (!fill) return;
            fill.classList.remove('bd-collection-ugc-story-modal__progress-fill--filled', 'bd-collection-ugc-story-modal__progress-fill--active');
            fill.style.width = '';
            fill.style.transitionDuration = '';
            if (idx < activeIndex) {
              fill.classList.add('bd-collection-ugc-story-modal__progress-fill--filled');
              fill.style.width = '100%';
            } else if (idx === activeIndex) {
              fill.classList.add('bd-collection-ugc-story-modal__progress-fill--active');
              var dur = parseFloat(seg.dataset.duration) || 5;
              fill.style.transitionDuration = dur + 's';
              fill.offsetHeight;
              fill.style.width = '100%';
            }
          });
        }

        function goNext() {
          if (currentIndex + 1 < modalSlides.length) {
            currentIndex++;
            goToSlide(currentIndex);
          } else {
            closeModal();
          }
        }

        function goPrev() {
          if (currentIndex > 0) {
            currentIndex--;
            goToSlide(currentIndex);
          }
        }

        function goToSlide(i) {
          if (advanceTimer) {
            clearTimeout(advanceTimer);
            advanceTimer = null;
          }
          pauseAllVideos();
          modalSlides.forEach(function(s, idx) {
            s.classList.toggle('bd-collection-ugc-story-modal__slide--active', idx === i);
          });
          updateProgressBars(i);
          modalBlockContents.forEach(function(bc, idx) {
            bc.hidden = (idx !== i);
          });
          var slide = modalSlides[i];
          if (!slide) return;
          var isVideo = slide.dataset.isVideo === 'true';
          var video = slide.querySelector('.bd-collection-ugc-story-modal__video');
          var durationMs = parseInt(slide.dataset.durationMs, 10) || 5000;
          if (isVideo && video) {
            video.pause();
            video.currentTime = 0;
            if (modalAutoAdvance) {
              video.onended = function() { goNext(); };
            }
            playStoryModalVideo(video, function() {
              if (modalAutoAdvance) advanceTimer = setTimeout(goNext, durationMs);
            }, modalEnableVideoSound);
            prefetchAdjacentStoryVideos(modalSlides, i);
          } else if (modalAutoAdvance) {
            advanceTimer = setTimeout(goNext, durationMs);
          }
        }

        function openModal(startIndex) {
          if (startIndex < 0 || startIndex >= modalSlides.length) return;
          pauseOtherRealSpacesVideos(null);
          currentIndex = startIndex;
          modal.removeAttribute('hidden');
          document.body.classList.add('overflow-hidden');
          document.querySelectorAll('.facets-container.facets-container-drawer').forEach(function(el) {
            el.classList.add('facets-container-drawer--ugc-modal-open');
          });
          goToSlide(currentIndex);
        }

        function closeModal() {
          if (advanceTimer) {
            clearTimeout(advanceTimer);
            advanceTimer = null;
          }
          pauseAllVideos();
          modal.setAttribute('hidden', '');
          document.body.classList.remove('overflow-hidden');
          document.querySelectorAll('.facets-container.facets-container-drawer').forEach(function(el) {
            el.classList.remove('facets-container-drawer--ugc-modal-open');
          });
        }

        if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
        if (modalOverlay) modalOverlay.addEventListener('click', closeModal);
        if (modalShowPrevNext) {
          if (modalPrevBtn) modalPrevBtn.addEventListener('click', goPrev);
          if (modalNextBtn) modalNextBtn.addEventListener('click', goNext);
        }
        progressSegs.forEach(function(seg) {
          seg.addEventListener('click', function() {
            var idx = parseInt(seg.dataset.index, 10);
            if (!isNaN(idx) && idx >= 0 && idx < modalSlides.length) {
              currentIndex = idx;
              goToSlide(currentIndex);
            }
          });
        });
        modal.addEventListener('keydown', function(e) {
          if (e.code === 'Escape') closeModal();
        });
        var track = modal.querySelector('.bd-collection-ugc-story-modal__track');
        if (track) initUgcStoryModalDragWheel(track, goPrev, goNext);
        scheduleStoryModalVideoWarmup(modal);
        modal._realSpacesStoryOpen = openModal;
      }

      panels.forEach(function(panel, panelIndex) {
        initPanelStoryModal(panelIndex);
      });

      section.addEventListener('click', function(e) {
        var blockItem = e.target && e.target.closest && e.target.closest('.bd-real-spaces__block-item');
        if (!blockItem) return;
        if (e.target.closest('.bd-real-spaces__product-img-wrap') || e.target.closest('.social-icons-main-container') || e.target.closest('.bd-real-spaces__play-button')) return;
        var panel = blockItem.closest('.bd-real-spaces__panel');
        if (!panel) return;
        var panelIndex = parseInt(panel.getAttribute('data-collection-index'), 10);
        var entryIndex = parseInt(blockItem.getAttribute('data-real-space-index'), 10);
        var modal = document.getElementById('bd-real-spaces-story-modal-' + sectionId + '-' + panelIndex);
        if (!modal || !modal._realSpacesStoryOpen || isNaN(entryIndex) || entryIndex < 0) return;
        var slides = modal.querySelectorAll('.bd-collection-ugc-story-modal__slide');
        if (entryIndex >= slides.length) return;
        modal._realSpacesStoryOpen(entryIndex);
      });

      var playButtons = section.querySelectorAll('.bd-real-spaces__play-button');
      playButtons.forEach(function(playButton) {
        const playIcon = playButton.querySelector('.bd-real-spaces__play-icon-svg');
        const pauseIcon = playButton.querySelector('.bd-real-spaces__pause-icon-svg');
        if (!playIcon || !pauseIcon) return;

        playButton.addEventListener('click', function(e) {
          e.stopPropagation();
          const blockItem = this.closest('.bd-real-spaces__block-item');
          if (!blockItem) return;
          const imagesParent = blockItem.querySelector('.bd-real-spaces__images-parent');
          const videoWrapper = blockItem.querySelector('.bd-real-spaces__video-wrapper');
          const video = blockItem.querySelector('.bd-real-spaces__video');
          if (!imagesParent || !videoWrapper || !video) return;

          imagesParent.classList.add('bd-real-spaces__images-parent--video-playing');
          videoWrapper.style.display = 'block';

          if (video.tagName === 'VIDEO') {
            if (video.paused) {
              pauseOtherRealSpacesVideos(video);
              if (enableVideoSound) {
                video.muted = false;
                video.removeAttribute('muted');
              } else {
                video.muted = true;
                video.setAttribute('muted', '');
              }
              var playPromise = video.play();
              if (playPromise && typeof playPromise.then === 'function') {
                playPromise.catch(function() {
                  if (enableVideoSound) {
                    video.muted = true;
                    video.setAttribute('muted', '');
                    video.play().catch(function() {});
                  }
                });
              }
              playIcon.style.display = 'none';
              pauseIcon.style.display = 'block';
              playButton.setAttribute('aria-label', 'Pause video');
            } else {
              video.pause();
              imagesParent.classList.remove('bd-real-spaces__images-parent--video-playing');
              playIcon.style.display = 'block';
              pauseIcon.style.display = 'none';
              playButton.setAttribute('aria-label', 'Play video');
            }
          }
        });

        const video = playButton.closest('.bd-real-spaces__block-item') && playButton.closest('.bd-real-spaces__block-item').querySelector('.bd-real-spaces__video');
        if (video && video.tagName === 'VIDEO') {
          video.addEventListener('play', function() {
            pauseOtherRealSpacesVideos(video);
            var parent = video.closest('.bd-real-spaces__images-parent');
            if (parent) parent.classList.add('bd-real-spaces__images-parent--video-playing');
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
            playButton.setAttribute('aria-label', 'Pause video');
          });
          video.addEventListener('pause', function() {
            var parent = video.closest('.bd-real-spaces__images-parent');
            if (parent) parent.classList.remove('bd-real-spaces__images-parent--video-playing');
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
            playButton.setAttribute('aria-label', 'Play video');
          });
          video.addEventListener('ended', function() {
            var parent = video.closest('.bd-real-spaces__images-parent');
            if (parent) parent.classList.remove('bd-real-spaces__images-parent--video-playing');
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
            playButton.setAttribute('aria-label', 'Play video');
          });
        }
      });
    });
  }

  // Find The Series
  function initFindTheSeries() {
    const sections = document.querySelectorAll('.bd-find-the-series[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const swiperElement = document.getElementById('bd-find-the-series-swiper-' + sectionId);
      if (!swiperElement) return;
      
      const loop = section.dataset.loop === 'true';
      const autoplay = section.dataset.autoplay === 'true';
      const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 3000;
      const slidesPerViewMobile = parseFloat(section.dataset.slidesPerViewMobile) || 2.5;
      const slidesPerViewTablet = parseFloat(section.dataset.slidesPerViewTablet) || 4;
      const slidesPerViewDesktop = parseFloat(section.dataset.slidesPerViewDesktop) || 6;
      // Access mobile gap - dataset API converts data-slides-gap-mobile to slidesGapMobile
      // But with multiple hyphens, getAttribute is more reliable
      let slidesGapMobile = 8; // default
      const gapMobileAttr = section.getAttribute('data-slides-gap-mobile');
      if (gapMobileAttr !== null && gapMobileAttr !== '' && gapMobileAttr !== 'undefined') {
        const parsed = parseInt(gapMobileAttr, 10);
        if (!isNaN(parsed) && parsed >= 0) {
          slidesGapMobile = parsed;
        }
      } else {
        // Fallback: try dataset API (camelCase conversion)
        const gapMobileDataset = section.dataset.slidesGapMobile;
        if (gapMobileDataset !== undefined && gapMobileDataset !== '' && gapMobileDataset !== 'undefined') {
          const parsed = parseInt(gapMobileDataset, 10);
          if (!isNaN(parsed) && parsed >= 0) {
            slidesGapMobile = parsed;
          }
        }
      }
      const slidesGap = parseInt(section.dataset.slidesGap) || 8;

      // UGC-style story modal (open when .bd-find-the-series__images-parent is clicked)
      const storyModal = document.getElementById('bd-find-the-series-story-modal-' + sectionId);
      const progressSegs = storyModal ? storyModal.querySelectorAll('.bd-collection-ugc-story-modal__progress-seg') : [];
      const modalSlides = storyModal ? storyModal.querySelectorAll('.bd-collection-ugc-story-modal__slide') : [];
      const modalCloseBtn = storyModal ? storyModal.querySelector('.bd-collection-ugc-story-modal__close') : null;
      const modalOverlay = storyModal ? storyModal.querySelector('.bd-collection-ugc-story-modal__overlay') : null;
      const modalPrevBtn = storyModal ? storyModal.querySelector('.bd-collection-ugc-story-modal__prev') : null;
      const modalNextBtn = storyModal ? storyModal.querySelector('.bd-collection-ugc-story-modal__next') : null;
      const modalBlockContents = storyModal ? storyModal.querySelectorAll('.bd-collection-ugc-story-modal__block-content') : [];
      const modalShowPrevNext = storyModal && storyModal.dataset.showPrevNext !== 'false';
      const modalAutoAdvance = storyModal && storyModal.dataset.autoAdvance !== 'false';
      const enableVideoSound = section.dataset.enableVideoSound === 'true'
        || (storyModal && storyModal.dataset.enableVideoSound === 'true');
      var storyModalIndex = 0;
      var storyAdvanceTimer = null;

      function pauseAllStoryModalVideos() {
        if (!storyModal) return;
        storyModal.querySelectorAll('.bd-collection-ugc-story-modal__video').forEach(function(v) {
          v.pause();
          v.onended = null;
        });
      }

      function updateStoryProgressBars(activeIndex) {
        progressSegs.forEach(function(seg, idx) {
          seg.classList.toggle('bd-collection-ugc-story-modal__progress-seg--active', idx === activeIndex);
          var fill = seg.querySelector('.bd-collection-ugc-story-modal__progress-fill');
          if (!fill) return;
          fill.classList.remove('bd-collection-ugc-story-modal__progress-fill--filled', 'bd-collection-ugc-story-modal__progress-fill--active');
          fill.style.width = '';
          fill.style.transitionDuration = '';
          if (idx < activeIndex) {
            fill.classList.add('bd-collection-ugc-story-modal__progress-fill--filled');
            fill.style.width = '100%';
          } else if (idx === activeIndex) {
            fill.classList.add('bd-collection-ugc-story-modal__progress-fill--active');
            var dur = parseFloat(seg.dataset.duration) || 5;
            fill.style.transitionDuration = dur + 's';
            fill.offsetHeight;
            fill.style.width = '100%';
          }
        });
      }

      function storyGoNext() {
        if (storyModalIndex + 1 < modalSlides.length) {
          storyModalIndex++;
          storyGoToSlide(storyModalIndex);
        } else {
          closeStoryModal();
        }
      }

      function storyGoPrev() {
        if (storyModalIndex > 0) {
          storyModalIndex--;
          storyGoToSlide(storyModalIndex);
        }
      }

      function storyGoToSlide(i) {
        if (storyAdvanceTimer) {
          clearTimeout(storyAdvanceTimer);
          storyAdvanceTimer = null;
        }
        pauseAllStoryModalVideos();
        modalSlides.forEach(function(s, idx) {
          s.classList.toggle('bd-collection-ugc-story-modal__slide--active', idx === i);
        });
        updateStoryProgressBars(i);
        modalBlockContents.forEach(function(bc, idx) {
          bc.hidden = (idx !== i);
        });
        var slide = modalSlides[i];
        if (!slide) return;
        var isVideo = slide.dataset.isVideo === 'true';
        var video = slide.querySelector('.bd-collection-ugc-story-modal__video');
        var durationMs = parseInt(slide.dataset.durationMs, 10) || 5000;
        if (isVideo && video) {
          video.pause();
          video.currentTime = 0;
          if (modalAutoAdvance) {
            video.onended = function() { storyGoNext(); };
          }
          playStoryModalVideo(video, function() {
            if (modalAutoAdvance) storyAdvanceTimer = setTimeout(storyGoNext, durationMs);
          }, enableVideoSound);
          prefetchAdjacentStoryVideos(modalSlides, i);
        } else if (modalAutoAdvance) {
          storyAdvanceTimer = setTimeout(storyGoNext, durationMs);
        }
      }

      function openStoryModal(startIndex) {
        if (!storyModal || startIndex < 0 || startIndex >= modalSlides.length) return;
        // Pause any in-card videos so only the modal audio/video plays.
        section.querySelectorAll('.bd-find-the-series__video').forEach(function(v) {
          if (v.tagName === 'VIDEO' && !v.paused) v.pause();
          var block = v.closest('.bd-find-the-series__block-item');
          var btn = block ? block.querySelector('.bd-find-the-series__play-button') : null;
          var imagesParent = block ? block.querySelector('.bd-find-the-series__images-parent') : null;
          if (btn) {
            var playIcon = btn.querySelector('.bd-find-the-series__play-icon-svg');
            var pauseIcon = btn.querySelector('.bd-find-the-series__pause-icon-svg');
            if (playIcon) playIcon.style.display = 'block';
            if (pauseIcon) pauseIcon.style.display = 'none';
            btn.setAttribute('aria-label', 'Play video');
          }
          if (imagesParent) imagesParent.classList.remove('bd-find-the-series__images-parent--video-playing');
        });
        storyModalIndex = startIndex;
        storyModal.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden');
        document.querySelectorAll('.facets-container.facets-container-drawer').forEach(function(el) {
          el.classList.add('facets-container-drawer--ugc-modal-open');
        });
        storyGoToSlide(storyModalIndex);
      }

      function closeStoryModal() {
        if (!storyModal) return;
        if (storyAdvanceTimer) {
          clearTimeout(storyAdvanceTimer);
          storyAdvanceTimer = null;
        }
        pauseAllStoryModalVideos();
        storyModal.setAttribute('hidden', '');
        document.body.classList.remove('overflow-hidden');
        document.querySelectorAll('.facets-container.facets-container-drawer').forEach(function(el) {
          el.classList.remove('facets-container-drawer--ugc-modal-open');
        });
      }

      if (storyModal) {
        if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeStoryModal);
        if (modalOverlay) modalOverlay.addEventListener('click', closeStoryModal);
        if (modalShowPrevNext) {
          if (modalPrevBtn) modalPrevBtn.addEventListener('click', storyGoPrev);
          if (modalNextBtn) modalNextBtn.addEventListener('click', storyGoNext);
        }
        progressSegs.forEach(function(seg) {
          seg.addEventListener('click', function() {
            var idx = parseInt(seg.dataset.index, 10);
            if (!isNaN(idx) && idx >= 0 && idx < modalSlides.length) {
              storyModalIndex = idx;
              storyGoToSlide(storyModalIndex);
            }
          });
        });
        storyModal.addEventListener('keydown', function(e) {
          if (e.code === 'Escape') closeStoryModal();
        });
        var storyTrack = storyModal.querySelector('.bd-collection-ugc-story-modal__track');
        if (storyTrack) initUgcStoryModalDragWheel(storyTrack, storyGoPrev, storyGoNext);
        scheduleStoryModalVideoWarmup(storyModal);
      }

      section.addEventListener('click', function(e) {
        var imagesParent = e.target && e.target.closest && e.target.closest('.bd-find-the-series__images-parent');
        if (!imagesParent) return;
        if (e.target.closest('.bd-find-the-series__overlay-img-link') || e.target.closest('.bd-find-the-series__play-button')) return;
        var blockItem = imagesParent.closest('.bd-find-the-series__block-item');
        if (!blockItem) return;
        var index = parseInt(blockItem.getAttribute('data-series-index'), 10);
        if (isNaN(index) || !storyModal || index < 0 || index >= modalSlides.length) return;
        openStoryModal(index);
      });

      // Get navigation buttons - use selector string so Swiper finds all matching buttons
      const prevButtonSelector = '.bd-find-the-series__nav-button--prev';
      const nextButtonSelector = '.bd-find-the-series__nav-button--next';
      
      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }
        const swiper = new Swiper(swiperElement, {
          loop: loop,
          mousewheel: {
            forceToAxis: true, // Ignores vertical (y-axis) scrolling
          },
          autoplay: autoplay ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          } : false,
          slidesPerView: slidesPerViewMobile,
          spaceBetween: slidesGapMobile,
          breakpoints: {
            640: {
              slidesPerView: slidesPerViewTablet,
              spaceBetween: slidesGap,
            },
            990: {
              slidesPerView: slidesPerViewDesktop,
              spaceBetween: slidesGap,
            },
          },
        });

        // Manually connect all navigation buttons (both desktop and mobile)
        const allPrevButtons = section.querySelectorAll(prevButtonSelector);
        const allNextButtons = section.querySelectorAll(nextButtonSelector);
        
        allPrevButtons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            swiper.slidePrev();
          });
        });
        
        allNextButtons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            swiper.slideNext();
          });
        });

        // Update button states for all navigation buttons
        function updateButtonStates() {
          if (!loop) {
            allPrevButtons.forEach(function(btn) {
              btn.disabled = swiper.isBeginning;
            });
            allNextButtons.forEach(function(btn) {
              btn.disabled = swiper.isEnd;
            });
          }
        }

        swiper.on('slideChange', updateButtonStates);
        updateButtonStates();

        function resetFindTheSeriesPlayButton(playButton) {
          if (!playButton) return;
          var playIcon = playButton.querySelector('.bd-find-the-series__play-icon-svg');
          var pauseIcon = playButton.querySelector('.bd-find-the-series__pause-icon-svg');
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
          playButton.setAttribute('aria-label', 'Play video');
        }

        function pauseOtherFindTheSeriesVideos(exceptVideo) {
          section.querySelectorAll('.bd-find-the-series__video').forEach(function(otherVideo) {
            if (exceptVideo && otherVideo === exceptVideo) return;
            var otherBlock = otherVideo.closest('.bd-find-the-series__block-item');
            var otherPlayButton = otherBlock ? otherBlock.querySelector('.bd-find-the-series__play-button') : null;
            var otherImagesParent = otherBlock ? otherBlock.querySelector('.bd-find-the-series__images-parent') : null;

            if (otherVideo.tagName === 'VIDEO' && !otherVideo.paused) {
              otherVideo.pause();
            } else if (otherVideo.tagName === 'IFRAME' && otherVideo.src) {
              try {
                if (otherVideo.src.includes('youtube.com') || otherVideo.src.includes('youtu.be')) {
                  otherVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } else if (otherVideo.src.includes('vimeo.com')) {
                  otherVideo.contentWindow.postMessage('{"method":"pause"}', '*');
                }
              } catch (err) {}
            }

            resetFindTheSeriesPlayButton(otherPlayButton);
            if (otherImagesParent) {
              otherImagesParent.classList.remove('bd-find-the-series__images-parent--video-playing');
            }
          });
        }
        
        // Handle video playback
        const playButtons = section.querySelectorAll('.bd-find-the-series__play-button');
        playButtons.forEach(function(playButton) {
          const playIcon = playButton.querySelector('.bd-find-the-series__play-icon-svg');
          const pauseIcon = playButton.querySelector('.bd-find-the-series__pause-icon-svg');
          
          playButton.addEventListener('click', function() {
            const blockItem = this.closest('.bd-find-the-series__block-item');
            if (!blockItem) return;
            
            const imagesParent = blockItem.querySelector('.bd-find-the-series__images-parent');
            const videoWrapper = blockItem.querySelector('.bd-find-the-series__video-wrapper');
            const video = blockItem.querySelector('.bd-find-the-series__video');
            
            if (!imagesParent || !videoWrapper || !video) return;
            
            // Show video and hide images
            imagesParent.classList.add('bd-find-the-series__images-parent--video-playing');
            videoWrapper.style.display = 'block';
            
            // Toggle play/pause
            if (video.tagName === 'VIDEO') {
              if (video.paused) {
                pauseOtherFindTheSeriesVideos(video);
                if (enableVideoSound) {
                  video.muted = false;
                  video.removeAttribute('muted');
                } else {
                  video.muted = true;
                  video.setAttribute('muted', '');
                }
                var playPromise = video.play();
                if (playPromise && typeof playPromise.then === 'function') {
                  playPromise.catch(function() {
                    if (enableVideoSound) {
                      video.muted = true;
                      video.setAttribute('muted', '');
                      video.play().catch(function() {});
                    }
                  });
                }
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
                playButton.setAttribute('aria-label', 'Pause video');
              } else {
                video.pause();
                imagesParent.classList.remove('bd-find-the-series__images-parent--video-playing');
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
                playButton.setAttribute('aria-label', 'Play video');
              }
            } else if (video.tagName === 'IFRAME') {
              // For iframe videos (YouTube, Vimeo, etc.), we need to handle differently
              // Note: iframe video control is more complex and may require postMessage API
              const src = video.src;
              if (src.includes('youtube.com') || src.includes('youtu.be')) {
                if (!video.src.includes('autoplay=1')) {
                  pauseOtherFindTheSeriesVideos(video);
                  var ytParams = 'autoplay=1';
                  if (enableVideoSound) ytParams += '&mute=0';
                  else ytParams += '&mute=1';
                  video.src = src + (src.includes('?') ? '&' : '?') + ytParams;
                  playIcon.style.display = 'none';
                  pauseIcon.style.display = 'block';
                  playButton.setAttribute('aria-label', 'Pause video');
                }
              } else if (src.includes('vimeo.com')) {
                if (!video.src.includes('autoplay=1')) {
                  pauseOtherFindTheSeriesVideos(video);
                  var vimeoParams = 'autoplay=1';
                  if (enableVideoSound) vimeoParams += '&muted=0';
                  else vimeoParams += '&muted=1';
                  video.src = src + (src.includes('?') ? '&' : '?') + vimeoParams;
                  playIcon.style.display = 'none';
                  pauseIcon.style.display = 'block';
                  playButton.setAttribute('aria-label', 'Pause video');
                }
              }
            }
          });
          
          // Listen for video events to update button state
          const video = playButton.closest('.bd-find-the-series__block-item')?.querySelector('.bd-find-the-series__video');
          if (video && video.tagName === 'VIDEO') {
            video.addEventListener('play', function() {
              pauseOtherFindTheSeriesVideos(video);
              var parent = video.closest('.bd-find-the-series__images-parent');
              if (parent) parent.classList.add('bd-find-the-series__images-parent--video-playing');
              playIcon.style.display = 'none';
              pauseIcon.style.display = 'block';
              playButton.setAttribute('aria-label', 'Pause video');
            });
            
            video.addEventListener('pause', function() {
              var parent = video.closest('.bd-find-the-series__images-parent');
              if (parent) parent.classList.remove('bd-find-the-series__images-parent--video-playing');
              playIcon.style.display = 'block';
              pauseIcon.style.display = 'none';
              playButton.setAttribute('aria-label', 'Play video');
            });
            
            video.addEventListener('ended', function() {
              var parent = video.closest('.bd-find-the-series__images-parent');
              if (parent) parent.classList.remove('bd-find-the-series__images-parent--video-playing');
              playIcon.style.display = 'block';
              pauseIcon.style.display = 'none';
              playButton.setAttribute('aria-label', 'Play video');
            });
          }
        });
      }

      initSwiper();
    });
  }

  var findTheSeriesDrawerDesktopQuery = window.matchMedia('(min-width: 750px)');

  function isFindTheSeriesDrawerDesktop() {
    return findTheSeriesDrawerDesktopQuery.matches;
  }

  function releaseFindTheSeriesDrawerScrollLockClasses() {
    document.documentElement.classList.remove('find-the-series-drawer-scroll-locked');
    document.body.classList.remove('overflow-hidden', 'find-the-series-drawer-scroll-locked');
  }

  function syncFindTheSeriesDrawerScrollLock() {
    var hasOpenDrawer = !!document.querySelector('.bd-find-the-series-drawer.is-open');
    if (!hasOpenDrawer) {
      releaseFindTheSeriesDrawerScrollLockClasses();
      return;
    }
    if (isFindTheSeriesDrawerDesktop()) {
      document.documentElement.classList.add('find-the-series-drawer-scroll-locked');
      document.body.classList.add('overflow-hidden', 'find-the-series-drawer-scroll-locked');
    } else {
      releaseFindTheSeriesDrawerScrollLockClasses();
    }
  }

  function preventFindTheSeriesDrawerBackgroundScroll(e) {
    if (!document.querySelector('.bd-find-the-series-drawer.is-open')) return;
    if (!isFindTheSeriesDrawerDesktop()) return;
    var panel = e.target && e.target.closest && e.target.closest('.bd-find-the-series-drawer__panel');
    if (panel) return;
    e.preventDefault();
  }

  function lockFindTheSeriesDrawerScroll() {
    syncFindTheSeriesDrawerScrollLock();
  }

  function unlockFindTheSeriesDrawerScroll() {
    syncFindTheSeriesDrawerScrollLock();
  }

  if (!document.documentElement.dataset.findTheSeriesDrawerScrollBound) {
    document.documentElement.dataset.findTheSeriesDrawerScrollBound = 'true';
    document.addEventListener('touchmove', preventFindTheSeriesDrawerBackgroundScroll, { passive: false });
    document.addEventListener('wheel', preventFindTheSeriesDrawerBackgroundScroll, { passive: false });
    findTheSeriesDrawerDesktopQuery.addEventListener('change', syncFindTheSeriesDrawerScrollLock);
  }

  function openProductDrawer(productUrl, drawer, body) {
    if (!drawer || !body) return;
    body.innerHTML = '<div class="bd-find-the-series-drawer__loading" aria-live="polite" aria-busy="true"><span class="bd-find-the-series-drawer__spinner" aria-hidden="true"></span></div>';
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockFindTheSeriesDrawerScroll();
    const url = productUrl.indexOf('http') === 0 ? productUrl : (window.location.origin + productUrl);
    const sectionParam = (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=bd-find-the-series-drawer-content';
    fetch(url + sectionParam)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const sectionEl = doc.querySelector('#shopify-section-bd-find-the-series-drawer-content') || doc.querySelector('.bd-find-the-series-drawer__product');
        const html = sectionEl ? sectionEl.innerHTML : '';
        body.innerHTML = html || '<p>Unable to load product.</p>';
      })
      .catch(function() {
        body.innerHTML = '<p>Unable to load product.</p>';
      });
  }

  // Find The Series – product drawer (overlay image link opens drawer from right)
  document.addEventListener('click', function(e) {
    const overlayLink = e.target && e.target.closest && e.target.closest('a.bd-find-the-series__overlay-img-link');
    if (!overlayLink) return;
    const productUrl = overlayLink.getAttribute('data-product-url');
    if (!productUrl) return;
    e.preventDefault();
    const section = overlayLink.closest('.bd-find-the-series[data-section-id]');
    if (!section) return;
    const sectionId = section.getAttribute('data-section-id');
    const drawer = document.getElementById('bd-find-the-series-drawer-' + sectionId);
    const body = drawer ? drawer.querySelector('.bd-find-the-series-drawer__body') : null;
    if (!body) return;
    openProductDrawer(productUrl, drawer, body);
  });

  // Real Spaces – product drawer (product image link opens same drawer)
  document.addEventListener('click', function(e) {
    const productLink = e.target && e.target.closest && e.target.closest('a.bd-real-spaces__product-img-link');
    if (!productLink) return;
    const productUrl = productLink.getAttribute('data-product-url') || productLink.getAttribute('href');
    if (!productUrl) return;
    e.preventDefault();
    const section = productLink.closest('.bd-real-spaces[data-section-id]');
    if (!section) return;
    const sectionId = section.getAttribute('data-section-id');
    const drawer = document.getElementById('bd-real-spaces-drawer-' + sectionId);
    const body = drawer ? drawer.querySelector('.bd-find-the-series-drawer__body') : null;
    if (!body) return;
    openProductDrawer(productUrl, drawer, body);
  });

  function closeFindTheSeriesDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.style.removeProperty('--bd-drawer-panel-height');
    unlockFindTheSeriesDrawerScroll();
    var sectionId = drawer.getAttribute('data-section-id');
    if (sectionId) {
      var trigger = document.querySelector('[data-promo-newsletter-drawer-trigger][data-section-id="' + sectionId + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function(e) {
    const drawer = e.target && e.target.closest && e.target.closest('.bd-find-the-series-drawer');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.target.closest('.bd-find-the-series-drawer__overlay') || e.target.closest('.bd-find-the-series-drawer__close')) {
      closeFindTheSeriesDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    const openDrawer = document.querySelector('.bd-find-the-series-drawer.is-open');
    if (openDrawer) closeFindTheSeriesDrawer(openDrawer);
  });

  // Promotional banner – newsletter drawer (button group opens drawer)
  document.addEventListener('click', function(e) {
    var trigger = e.target && e.target.closest && e.target.closest('[data-promo-newsletter-drawer-trigger]');
    if (!trigger) return;
    var sectionId = trigger.getAttribute('data-section-id');
    if (!sectionId) return;
    var drawer = document.getElementById('bd-promotional-banner-newsletter-drawer-' + sectionId);
    if (!drawer) return;
    e.preventDefault();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    lockFindTheSeriesDrawerScroll();
  });

  // Featured Products
  function initFeaturedProducts() {
    const sections = document.querySelectorAll('.bd-featured-products[data-section-id]');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const tabs = section.querySelectorAll('.bd-featured-products__tab');
      const productWrappers = section.querySelectorAll('.bd-featured-products__products-wrapper');
      const imageWrappers = section.querySelectorAll('.bd-featured-products__image-wrapper');
      
      if (!tabs.length || !productWrappers.length) return;
      
      // Initialize mobile sliders
      const grids = section.querySelectorAll('.bd-featured-products__grid--slider');
      const sliders = {};
      
      grids.forEach(function(grid) {
        const sliderWrapper = grid.querySelector('.bd-featured-products__slider-wrapper');
        if (!sliderWrapper) return;
        
        if (sliderWrapper.swiper) {
          sliderWrapper.swiper.destroy(true, true);
        }
        const slidesPerView = parseFloat(grid.dataset.slidesPerView) || 1.25;
        const spaceBetween = parseInt(getComputedStyle(grid).getPropertyValue('--grid-column-gap')) || 16;
        
        const swiper = new Swiper(sliderWrapper, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: false,
          breakpoints: {
            750: {
              slidesPerView: 'auto',
              spaceBetween: 0,
              enabled: false
            }
          }
        });
        
        const wrapperId = grid.closest('.bd-featured-products__products-wrapper').dataset.collectionHandle;
        if (wrapperId) {
          sliders[wrapperId] = swiper;
        }
      });
      
      // Set initial active state
      const firstTab = tabs[0];
      if (firstTab) {
        firstTab.classList.add('bd-featured-products__tab--active');
        const collectionHandle = firstTab.dataset.collectionHandle;
        if (collectionHandle) {
          const firstWrapper = section.querySelector(`.bd-featured-products__products-wrapper[data-collection-handle="${collectionHandle}"]`);
          if (firstWrapper) {
            firstWrapper.classList.add('bd-featured-products__products-wrapper--active');
            if (sliders[collectionHandle]) {
              sliders[collectionHandle].update();
            }
          }
          
          const firstImageWrapper = section.querySelector(`.bd-featured-products__image-wrapper[data-collection-handle="${collectionHandle}"]`);
          if (firstImageWrapper) {
            firstImageWrapper.classList.add('bd-featured-products__image-wrapper--active');
          }
        }
      }
      
      // Handle tab clicks
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const collectionHandle = this.dataset.collectionHandle;
          if (!collectionHandle) return;
          
          // Update active tab
          tabs.forEach(function(t) {
            t.classList.remove('bd-featured-products__tab--active');
          });
          this.classList.add('bd-featured-products__tab--active');
          
          // Update active products wrapper
          productWrappers.forEach(function(wrapper) {
            wrapper.classList.remove('bd-featured-products__products-wrapper--active');
          });
          
          const targetWrapper = section.querySelector(`.bd-featured-products__products-wrapper[data-collection-handle="${collectionHandle}"]`);
          if (targetWrapper) {
            targetWrapper.classList.add('bd-featured-products__products-wrapper--active');
            if (sliders[collectionHandle]) {
              sliders[collectionHandle].update();
              sliders[collectionHandle].slideTo(0, 0);
            }
          }
          
          // Update active image wrapper
          imageWrappers.forEach(function(wrapper) {
            wrapper.classList.remove('bd-featured-products__image-wrapper--active');
          });
          
          const targetImageWrapper = section.querySelector(`.bd-featured-products__image-wrapper[data-collection-handle="${collectionHandle}"]`);
          if (targetImageWrapper) {
            targetImageWrapper.classList.add('bd-featured-products__image-wrapper--active');
          }
        });
      });
    });
  }

  // FAQ – use event delegation so it works after theme editor re-renders the section
  function initFAQ() {
    const sections = document.querySelectorAll('.bd-faq[data-section-id]');
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const faqSection = document.getElementById('bd-faq-section-' + sectionId);
      if (!faqSection) return;
      const tabs = faqSection.querySelectorAll('.bd-faq__tab');
      const items = faqSection.querySelectorAll('.bd-faq__item');
      if (tabs.length > 0) {
        tabs.forEach(function(t) {
          t.classList.toggle('active', t === tabs[0]);
        });
        items.forEach(function(i) {
          const tabName = tabs[0].dataset.tab;
          const isMatch = i.dataset.tab === tabName;
          i.classList.toggle('active', isMatch);
          i.classList.remove('open');
          if (isMatch && i.classList.contains('default-open')) i.classList.add('open');
        });
      }
    });
  }

  function handleFAQClick(e) {
    const tab = e.target.closest('.bd-faq__tab');
    const question = e.target.closest('.bd-faq__question');
    const categoryWrapper = e.target.closest('.bd-faq__question-category-wrapper');
    if (!tab && !question && !categoryWrapper) return;
    const bdFaq = (tab || question || categoryWrapper).closest('.bd-faq');
    if (!bdFaq || !bdFaq.dataset.sectionId) return;
    const faqSection = document.getElementById('bd-faq-section-' + bdFaq.dataset.sectionId);
    if (!faqSection) return;
    const allTabs = faqSection.querySelectorAll('.bd-faq__tab');
    const allItems = faqSection.querySelectorAll('.bd-faq__item');

    if (tab) {
      const tabName = tab.dataset.tab;
      allTabs.forEach(function(t) {
        t.classList.toggle('active', t.dataset.tab === tabName);
      });
      allItems.forEach(function(i) {
        const isMatch = i.dataset.tab === tabName;
        i.classList.toggle('active', isMatch);
        i.classList.remove('open');
        if (isMatch && i.classList.contains('default-open')) i.classList.add('open');
      });
      return;
    }
    if (question || categoryWrapper) {
      const trigger = question || categoryWrapper;
      const item = trigger.closest('.bd-faq__item');
      if (!item) return;
      const isOpening = !item.classList.contains('open');
      allItems.forEach(function(i) {
        if (i !== item && i.dataset.tab === item.dataset.tab) i.classList.remove('open');
      });
      if (isOpening) item.classList.add('open');
      else item.classList.remove('open');
    }
  }

  document.addEventListener('click', handleFAQClick);

  // Features List - Collapse/Expand functionality
  function initFeaturesList() {
    const sections = document.querySelectorAll('.bd-features-list[data-section-id]');
    
    function isMobile() {
      return window.innerWidth < 1024;
    }
    
    sections.forEach(function(section) {
      const itemLinks = section.querySelectorAll('.bd-features-list__item-link');
      
      itemLinks.forEach(function(itemLink) {
        const content = itemLink.querySelector('.bd-features-list__content');
        if (!content) return;
        
        // Prevent clicks on content from triggering the toggle
        content.addEventListener('click', function(e) {
          if (isMobile()) {
            e.stopPropagation();
          }
        });
        
        // Prevent clicks on button inside content from triggering toggle
        const button = content.querySelector('.bd-features-list__button');
        if (button) {
          button.addEventListener('click', function(e) {
            if (isMobile()) {
              e.stopPropagation();
            }
          });
        }
        
        // Handle click on item-link (but not on content)
        itemLink.addEventListener('click', function(e) {
          // Only work on screens under 1024px
          if (!isMobile()) return;
          
          // Don't toggle if clicking on content or its children
          if (e.target.closest('.bd-features-list__content')) return;
          
          // Prevent default navigation if it's an anchor tag
          if (itemLink.tagName === 'A') {
            e.preventDefault();
          }
          
          // Check if this item is currently open
          const isHidden = content.style.display === 'none' || 
                          (window.getComputedStyle(content).display === 'none' && !content.style.display);
          
          // Close all other items in the same section
          const allItemLinks = section.querySelectorAll('.bd-features-list__item-link');
          allItemLinks.forEach(function(otherItemLink) {
            if (otherItemLink !== itemLink) {
              const otherContent = otherItemLink.querySelector('.bd-features-list__content');
              if (otherContent) {
                otherItemLink.classList.remove('bd-features-list__item-link--expanded');
                // Use setTimeout to allow transition to complete before hiding
                setTimeout(function() {
                  if (!otherItemLink.classList.contains('bd-features-list__item-link--expanded')) {
                    otherContent.style.display = 'none';
                  }
                }, 300);
              }
            }
          });
          
          // Toggle current item
          if (isHidden) {
            content.style.display = 'block';
            // Force reflow to ensure display: block is applied before transition
            content.offsetHeight;
            itemLink.classList.add('bd-features-list__item-link--expanded');
          } else {
            itemLink.classList.remove('bd-features-list__item-link--expanded');
            // Use setTimeout to allow transition to complete before hiding
            setTimeout(function() {
              if (!itemLink.classList.contains('bd-features-list__item-link--expanded')) {
                content.style.display = 'none';
              }
            }, 300);
          }
        });
      });
    });
    
    // Handle window resize to reset state if needed
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!isMobile()) {
          // On desktop, ensure content is visible
          sections.forEach(function(section) {
            const contents = section.querySelectorAll('.bd-features-list__content');
            contents.forEach(function(content) {
              content.style.display = '';
            });
            const itemLinks = section.querySelectorAll('.bd-features-list__item-link');
            itemLinks.forEach(function(itemLink) {
              itemLink.classList.remove('bd-features-list__item-link--expanded');
            });
          });
        }
      }, 250);
    });
  }

  // Sync header layout metrics before opening configurator drawer externally
  function syncHeaderButtonsDrawerLayout() {
    const headerWrapper = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
    const stickyHeader = document.querySelector('sticky-header');
    const header = document.querySelector('.section-header');
    if (!header) return;

    if (stickyHeader) {
      stickyHeader.preventHide = true;
      stickyHeader.preventReveal = false;
    }

    header.classList.remove('shopify-section-header-hidden');
    header.classList.add('shopify-section-header-sticky');

    if (headerWrapper) {
      headerWrapper.classList.add('header-wrapper--scrolled');
      headerWrapper.classList.remove('header-wrapper--scroll-hidden');
      headerWrapper.dataset.drawerOpen = 'true';
    }

    document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');

    const borderOffset = headerWrapper && headerWrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    const headerBar = document.querySelector('sticky-header .header') || document.querySelector('.header');
    const measureEl = headerBar || header;
    let headerBottom = Math.round(measureEl.getBoundingClientRect().bottom - borderOffset);

    // Body scroll-lock can shift sticky .section-header off-screen; clamp to visible header height
    if (headerBottom <= 0 || headerBottom > window.innerHeight * 1.5) {
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10)
        || measureEl.offsetHeight
        || 80;
      headerBottom = headerHeight;
    }

    document.documentElement.style.setProperty('--header-bottom-position', headerBottom + 'px');
  }

  function ensureHeaderButtonsDrawerLayoutMaintainer() {
    if (document.documentElement.dataset.headerButtonsDrawerLayoutMaintainerBound === 'true') return;
    document.documentElement.dataset.headerButtonsDrawerLayoutMaintainerBound = 'true';

    function maintainHeaderButtonsDrawerLayout() {
      if (!isHeaderButtonsDrawerOpen()) return;
      syncHeaderButtonsDrawerLayout();
    }

    window.addEventListener('scroll', maintainHeaderButtonsDrawerLayout, { passive: true });
    window.addEventListener('resize', maintainHeaderButtonsDrawerLayout, { passive: true });
  }

  var headerButtonsDrawerScrollLocked = false;

  function isHeaderButtonsDrawerOpen() {
    return !!document.querySelector('.header-buttons-drawer[open]:not(.header-buttons-drawer--closing)');
  }

  function shouldSuppressCollectionFilterBar() {
    if (isHeaderButtonsDrawerOpen()) return true;
    if (document.querySelector('.menu-drawer-container[open]')) return true;
    var searchDetails = document.querySelector('details-modal.header__search details');
    return !!(searchDetails && searchDetails.hasAttribute('open'));
  }

  function lockHeaderButtonsDrawerScroll() {
    if (headerButtonsDrawerScrollLocked) return;
    headerButtonsDrawerScrollLocked = true;
    document.documentElement.classList.add('header-buttons-drawer-scroll-locked');
    document.body.classList.add('overflow-hidden', 'header-buttons-drawer-scroll-locked');
  }

  function unlockHeaderButtonsDrawerScroll() {
    if (!headerButtonsDrawerScrollLocked) return;
    headerButtonsDrawerScrollLocked = false;
    document.documentElement.classList.remove('header-buttons-drawer-scroll-locked');
    document.body.classList.remove('header-buttons-drawer-scroll-locked');
  }

  function releaseHeaderButtonsDrawerHidePrevention() {
    const stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;
    const menuDrawerOpen = !!document.querySelector('.menu-drawer-container[open]');
    const megaMenuOpen = !!document.querySelector('.mega-menu--custom[open], .mega-menu[open], details.mega-menu[open]');
    if (!menuDrawerOpen && !megaMenuOpen && !isHeaderButtonsDrawerOpen()) {
      stickyHeader.preventHide = false;
    }
  }

  function preventHeaderButtonsDrawerBackgroundScroll(e) {
    if (!isHeaderButtonsDrawerOpen()) return;
    var openDrawer = document.querySelector('.header-buttons-drawer[open]');
    if (!openDrawer) return;
    var panel = openDrawer.querySelector('.header-buttons-drawer__panel');
    if (panel && (panel === e.target || panel.contains(e.target))) return;
    e.preventDefault();
  }

  // Open header configurator drawer from external triggers — same path as Konfigurator summary click
  function openHeaderButtonsDrawerFromExternal() {
    const drawer = document.querySelector('.header-buttons-drawer');
    if (!drawer || drawer.hasAttribute('open')) return false;

    const summary = drawer.querySelector('summary.header-buttons-drawer__trigger');
    if (!summary) return false;

    syncHeaderButtonsDrawerLayout();
    headerButtonsDrawerExternalOpenUntil = Date.now() + 500;
    summary.click();

    return drawer.hasAttribute('open');
  }

  // Open header configurator drawer from external triggers (e.g. split content circle, Build Your Sofa)
  function initHeaderButtonsDrawerExternalTriggers() {
    if (document.documentElement.dataset.headerButtonsDrawerExternalTriggersBound === 'true') return;
    document.documentElement.dataset.headerButtonsDrawerExternalTriggersBound = 'true';

    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-open-header-buttons-drawer]');
      if (!trigger) return;

      e.preventDefault();
      openHeaderButtonsDrawerFromExternal();
    });
  }

  // Build Your Sofa - Auto-switching states
  function initBuildYourSofa() {
    const sections = document.querySelectorAll('.bd-build-your-sofa__container[data-section-id]');
    
    sections.forEach(function(container) {
      const states = container.querySelectorAll('.bd-build-your-sofa__state');
      if (states.length < 2) return; // Need at least 2 states to switch
      
      // Check if animation is enabled
      const enableAnimation = container.dataset.enableAnimation !== 'false';
      if (!enableAnimation) {
        // Just initialize first state and return
        states.forEach(function(state, index) {
          if (index === 0) {
            state.classList.add('bd-build-your-sofa__state--active');
          } else {
            state.classList.remove('bd-build-your-sofa__state--active');
          }
        });
        return;
      }
      
      const transitionDelay = parseInt(container.dataset.transitionDelay) || 3000;
      let currentStateIndex = 0;
      let transitionInterval;
      
      function switchToState(index) {
        // Remove active class from all states
        states.forEach(function(state) {
          state.classList.remove('bd-build-your-sofa__state--active');
        });
        
        // Add active class to current state
        if (states[index]) {
          states[index].classList.add('bd-build-your-sofa__state--active');
        }
      }
      
      function nextState() {
        currentStateIndex = (currentStateIndex + 1) % states.length;
        switchToState(currentStateIndex);
      }
      
      // Initialize first state
      switchToState(0);
      
      // Start auto-switching
      transitionInterval = setInterval(nextState, transitionDelay);
      
      // Pause on hover (optional - can be removed if not needed)
      container.addEventListener('mouseenter', function() {
        if (transitionInterval) {
          clearInterval(transitionInterval);
        }
      });
      
      container.addEventListener('mouseleave', function() {
        transitionInterval = setInterval(nextState, transitionDelay);
      });
    });
  }

  // Footer Collapsible Menus
  function initFooterCollapsible() {
    const footerMenus = document.querySelectorAll('.footer-block--menu');
    
    function setupCollapsible() {
      const isMobile = window.innerWidth <= 749;
      
      footerMenus.forEach(function(menu) {
        const headingWrapper = menu.querySelector('.footer-block__heading-wrapper');
        if (!headingWrapper) return;
        
        if (isMobile) {
          // On mobile: add collapsed class
          if (!menu.classList.contains('footer-block--collapsed')) {
            menu.classList.add('footer-block--collapsed');
          }
        } else {
          // On desktop: remove collapsed class
          menu.classList.remove('footer-block--collapsed');
        }
      });
    }
    
    // Set up click handlers once
    footerMenus.forEach(function(menu) {
      const headingWrapper = menu.querySelector('.footer-block__heading-wrapper');
      if (!headingWrapper) return;
      
      // Remove any existing listeners by using a flag
      if (headingWrapper.dataset.listenerAdded !== 'true') {
        headingWrapper.addEventListener('click', function() {
          if (window.innerWidth <= 749) {
            menu.classList.toggle('footer-block--collapsed');
          }
        });
        headingWrapper.dataset.listenerAdded = 'true';
      }
    });
    
    // Initial setup
    setupCollapsible();
    
    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setupCollapsible, 250);
    });
  }

  // Mega Menu Dynamic Switching
  function initMegaMenu() {
    const megaMenus = document.querySelectorAll('.mega-menu--custom');
    const headerWrapper = document.querySelector('.header-wrapper');
    const headerElement = headerWrapper ? headerWrapper.querySelector('.header') : null;
    const closeButton = headerWrapper ? headerWrapper.querySelector('.header__mega-menu-close') : null;
    
    if (!headerWrapper) return;
    
    let megaMenuOpenCount = 0;
    
    megaMenus.forEach(function(megaMenu) {
      const content = megaMenu.querySelector('.mega-menu__content--custom');
      if (!content) return;
      
      const leftLinks = content.querySelectorAll('.mega-menu__left-link');
      const slides = content.querySelectorAll('.mega-menu__slider-slide');
      
      if (!leftLinks.length || !slides.length) return;
      
      let swipers = [];
      
      function initSwiperForSlide(slide, index) {
        if (typeof Swiper === 'undefined') {
          setTimeout(function() { initSwiperForSlide(slide, index); }, 100);
          return;
        }
        
        const swiperContainer = slide.querySelector('.mega-menu__products-swiper');
        if (!swiperContainer) return;
        
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(true, true);
        }
        const slidesPerView = parseFloat(slide.dataset.slidesPerView) || 4.5;
        const spaceBetween = parseInt(slide.dataset.slidesGap) || 8;
        
        // Initialize Swiper
        const swiper = new Swiper(swiperContainer, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: false,
          allowTouchMove: true,
        });
        
        swipers[index] = swiper;
      }
      
      function showSlide(index) {
        // Update active link
        leftLinks.forEach(function(link, i) {
          if (i === index) {
            link.classList.add('mega-menu__left-link--active');
          } else {
            link.classList.remove('mega-menu__left-link--active');
          }
        });
        
        // Update active slide
        slides.forEach(function(slide, i) {
          if (i === index) {
            slide.classList.add('mega-menu__slider-slide--active');
            slide.classList.remove('mega-menu__slider-slide--hidden');
            
            // Initialize Swiper for this slide if not already done
            if (!swipers[i]) {
              setTimeout(function() {
                initSwiperForSlide(slide, i);
              }, 50);
            } else {
              // Update Swiper if it exists
              swipers[i].update();
            }
          } else {
            slide.classList.remove('mega-menu__slider-slide--active');
            slide.classList.add('mega-menu__slider-slide--hidden');
          }
        });
      }
      
      // Add click handlers to left menu links (only prevent default when link has panel content; otherwise use as normal link)
      leftLinks.forEach(function(link, index) {
        link.addEventListener('click', function(e) {
          if (link.dataset.hasPanel !== 'true') {
            return; // No panel: allow default link navigation
          }
          e.preventDefault();
          showSlide(index);
        });
      });
      
      // Handle mega menu open/close and apply scrolled header styling
      megaMenu.addEventListener('toggle', function() {
        if (megaMenu.open) {
          // Track that a mega menu is open
          megaMenuOpenCount++;
          
          // Add scrolled class to header wrapper (same as when scrolled)
          headerWrapper.classList.add('header-wrapper--scrolled');
          headerWrapper.dataset.megaMenuOpen = 'true';
          if (headerElement) {
            headerElement.classList.add('header--mega-menu-open');
            if (document.querySelector('.header-buttons-drawer[open]')) {
              headerElement.classList.remove('header--buttons-drawer-only-open');
              headerElement.classList.add('header--mega-menu-and-buttons-drawer-open');
            } else {
              headerElement.classList.remove('header--buttons-drawer-open', 'header--buttons-drawer-only-open');
            }
          }
          
          setTimeout(function() {
            showSlide(0); // Show first slide
            slides.forEach(function(slide, i) {
              if (i === 0) {
                initSwiperForSlide(slide, i);
              }
            });
          }, 100);
        } else {
          // Track that a mega menu closed
          megaMenuOpenCount = Math.max(0, megaMenuOpenCount - 1);
          
          // Remove scrolled class only if no mega menus are open and page is not scrolled
          if (megaMenuOpenCount === 0) {
            headerWrapper.removeAttribute('data-mega-menu-open');
            if (headerElement) {
              headerElement.classList.remove('header--mega-menu-open', 'header--mega-menu-and-buttons-drawer-open');
              if (document.querySelector('.header-buttons-drawer[open]')) {
                headerElement.classList.add('header--buttons-drawer-only-open');
              }
            }
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop <= 50) {
              headerWrapper.classList.remove('header-wrapper--scrolled');
            }
          }
        }
      });
      
      // Initialize on page load if menu is already open
        if (megaMenu.open) {
        megaMenuOpenCount++;
        headerWrapper.classList.add('header-wrapper--scrolled');
        headerWrapper.dataset.megaMenuOpen = 'true';
        if (headerElement) {
          headerElement.classList.add('header--mega-menu-open');
          if (document.querySelector('.header-buttons-drawer[open]')) {
            headerElement.classList.remove('header--buttons-drawer-only-open');
            headerElement.classList.add('header--mega-menu-and-buttons-drawer-open');
          } else {
            headerElement.classList.remove('header--buttons-drawer-open', 'header--buttons-drawer-only-open');
          }
        }
        setTimeout(function() {
          showSlide(0);
          initSwiperForSlide(slides[0], 0);
        }, 100);
      }
    });
    
    // Global close button handler - when buttons drawer is open only close that; otherwise close mega menu / search and reset
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        const headerButtonsDrawersOpen = document.querySelectorAll('.header-buttons-drawer[open]');
        if (headerButtonsDrawersOpen.length > 0) {
          // Only close the header-buttons-drawer panel(s); keep mega menu open and header-wrapper--scrolled
          headerButtonsDrawersOpen.forEach(function(details) {
            details.removeAttribute('open');
          });
          return;
        }

        // Close all custom mega menus
        megaMenus.forEach(function(megaMenu) {
          if (megaMenu.open) {
            megaMenu.open = false;
          }
        });

        // Close predictive search modal so header--mega-menu-open is removed
        const searchModal = document.querySelector('details-modal.header__search');
        if (searchModal && typeof searchModal.close === 'function' && searchModal.isOpen()) {
          searchModal.close(false);
        }

        megaMenuOpenCount = 0;
        headerWrapper.removeAttribute('data-mega-menu-open');
        headerWrapper.removeAttribute('data-drawer-open');
        headerWrapper.removeAttribute('data-search-open');
        if (headerElement) {
          headerElement.classList.remove('header--mega-menu-open', 'header--buttons-drawer-open', 'header--mega-menu-and-buttons-drawer-open', 'header--buttons-drawer-only-open');
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop <= 50) {
          headerWrapper.classList.remove('header-wrapper--scrolled');
        }
      });
    }
    
    // Prevent scroll handler from removing scrolled class when mega menu, drawer or search is open
    if (headerWrapper.dataset.transparentHeader === 'true') {
      const originalHandleScroll = window.handleScroll;
      window.addEventListener('scroll', function() {
        const hasMegaMenuOpen = headerWrapper.dataset.megaMenuOpen === 'true';
        const hasDrawerOpen = headerWrapper.dataset.drawerOpen === 'true';
        const hasSearchOpen = headerWrapper.dataset.searchOpen === 'true';
        if (hasMegaMenuOpen || hasDrawerOpen || hasSearchOpen) {
          // Keep scrolled class when mega menu, drawer or search is open
          headerWrapper.classList.add('header-wrapper--scrolled');
        }
      }, { passive: true });
    }
  }

  // Menu Drawer Category Sliders
  function initMenuDrawerCategorySliders() {
    const menuDrawer = document.querySelector('#menu-drawer');
    if (!menuDrawer) return;
    
    // Find all submenus
    const submenus = menuDrawer.querySelectorAll('.menu-drawer__inner-submenu');
    
    submenus.forEach(function(submenu) {
      const menuItems = submenu.querySelectorAll('.menu-drawer__menu-item--has-slider');
      const categorySliders = submenu.querySelectorAll('.menu-drawer__category-slider');
      
      if (!menuItems.length || !categorySliders.length) return;
      
      // Initialize all sliders (but keep them hidden except the first)
      categorySliders.forEach(function(slider) {
        const swiperContainer = slider.querySelector('.menu-drawer__category-swiper');
        if (!swiperContainer) return;
        
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(true, true);
        }
        
        function initSwiper() {
          if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
            return;
          }
          if (swiperContainer.swiper) return;
          
          // Get settings from data attributes or use defaults
          const slidesPerView = parseFloat(swiperContainer.dataset.slidesPerView) || 3;
          const spaceBetween = parseInt(swiperContainer.dataset.slidesGap) || 4;
          
          // Initialize Swiper for category slider
          const swiper = new Swiper(swiperContainer, {
            slidesPerView: slidesPerView,
            spaceBetween: spaceBetween,
            loop: false,
            allowTouchMove: true,
            freeMode: true,
          });
        }
        
        // Initialize when the drawer submenu is opened
        const parentSubmenu = slider.closest('.menu-drawer__submenu');
        if (parentSubmenu) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                const details = parentSubmenu.closest('details');
                if (details && details.open) {
                  setTimeout(initSwiper, 100);
                }
              }
            });
          });
          
          const details = parentSubmenu.closest('details');
          if (details) {
            observer.observe(details, { attributes: true });
            
            // Initialize if already open
            if (details.open) {
              setTimeout(initSwiper, 100);
            }
          }
        } else {
          // Fallback: initialize immediately if submenu structure is different
          setTimeout(initSwiper, 100);
        }
      });
      
      // Handle menu item clicks to show/hide sliders
      menuItems.forEach(function(menuItem) {
        menuItem.addEventListener('click', function(e) {
          // Prevent default navigation if it's a collection link with slider
          const sliderHandle = this.dataset.sliderHandle;
          if (!sliderHandle) return;
          
          e.preventDefault();
          e.stopPropagation();
          
          // Hide all sliders in this submenu
          categorySliders.forEach(function(slider) {
            slider.classList.add('menu-drawer__category-slider--hidden');
          });
          
          // Show the clicked link's slider
          const targetSlider = submenu.querySelector('.menu-drawer__category-slider[data-link-handle="' + sliderHandle + '"]');
          if (targetSlider) {
            targetSlider.classList.remove('menu-drawer__category-slider--hidden');
            
            // Initialize Swiper if not already done
            const swiperContainer = targetSlider.querySelector('.menu-drawer__category-swiper');
            if (swiperContainer && typeof Swiper !== 'undefined') {
              if (swiperContainer.swiper) {
                swiperContainer.swiper.destroy(true, true);
              }
              // Get settings from data attributes or use defaults
              const slidesPerView = parseFloat(swiperContainer.dataset.slidesPerView) || 3;
              const spaceBetween = parseInt(swiperContainer.dataset.slidesGap) || 4;
              
              const swiper = new Swiper(swiperContainer, {
                slidesPerView: slidesPerView,
                spaceBetween: spaceBetween,
                loop: false,
                allowTouchMove: true,
                freeMode: true,
              });
            } else if (swiperContainer && swiperContainer.swiper) {
              swiperContainer.swiper.update();
            }
          }
          
          // Update active state
          menuItems.forEach(function(item) {
            item.classList.remove('menu-drawer__menu-item--slider-active');
          });
          this.classList.add('menu-drawer__menu-item--slider-active');
        });
      });
      
      // Show first slider by default if it exists
      const firstMenuItem = menuItems[0];
      if (firstMenuItem) {
        const firstSliderHandle = firstMenuItem.dataset.sliderHandle;
        if (firstSliderHandle) {
          const firstSlider = submenu.querySelector('.menu-drawer__category-slider[data-link-handle="' + firstSliderHandle + '"]');
          if (firstSlider) {
            firstSlider.classList.remove('menu-drawer__category-slider--hidden');
            firstMenuItem.classList.add('menu-drawer__menu-item--slider-active');
          }
        }
      }
    });
    
    // Handle back button clicks - MenuDrawer will handle the animation automatically
    // The button is inside a details element, so MenuDrawer's onCloseButtonClick will handle it
    // We just need to ensure it triggers properly
    const backButtons = menuDrawer.querySelectorAll('.menu-drawer__back-button[data-close-submenu]');
    backButtons.forEach(function(backButton) {
      // The MenuDrawer class already binds click handlers to buttons
      // Our button will work automatically, but we can ensure it's properly set up
      if (!backButton.dataset.listenerAdded) {
        backButton.dataset.listenerAdded = 'true';
        // The MenuDrawer's bindEvents will handle the click automatically
        // No need for custom handler - it will use closeSubmenu with animation
      }
    });
  }

  // When predictive search (details-modal.header__search) opens, add header--mega-menu-open to header
  function initHeaderSearchMegaMenuClass() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const headerElement = headerWrapper ? headerWrapper.querySelector('.header') : null;
    const searchModal = document.querySelector('details-modal.header__search');
    if (!headerWrapper || !headerElement || !searchModal) return;

    const details = searchModal.querySelector('details');
    if (!details) return;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName !== 'open') return;
        if (details.hasAttribute('open')) {
          headerWrapper.dataset.searchOpen = 'true';
          headerWrapper.classList.add('header-wrapper--scrolled');
          headerElement.classList.add('header--mega-menu-open', 'header--predictive-search-open');

          // When search modal opens, hide sticky collection filters bar (remove in-grid helper class)
          document.querySelectorAll('.filters-stikcy-wrapper-bd-collection-page--in-grid').forEach(function(barEl) {
            barEl.classList.remove('filters-stikcy-wrapper-bd-collection-page--in-grid');
          });
        } else {
          // When search modal closes, restore sticky filters bar visibility;
          // IntersectionObserver will continue to hide/show it on scroll.
          var bar = document.querySelector('.filters-stikcy-wrapper-bd-collection-page');
          if (bar) {
            bar.classList.add('filters-stikcy-wrapper-bd-collection-page--in-grid');
          }

          headerWrapper.removeAttribute('data-search-open');
          headerElement.classList.remove('header--predictive-search-open');
          const hasMegaMenuOpen = headerWrapper.dataset.megaMenuOpen === 'true';
          const hasDrawerOpen = headerWrapper.dataset.drawerOpen === 'true';
          if (!hasMegaMenuOpen && !hasDrawerOpen) {
            headerElement.classList.remove('header--mega-menu-open');
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop <= 50) {
              headerWrapper.classList.remove('header-wrapper--scrolled');
            }
          }
        }
      });
    });

    observer.observe(details, { attributes: true, attributeFilter: ['open'] });

    // Apply class on load if search is already open (e.g. from back/forward)
    if (details.hasAttribute('open')) {
      headerWrapper.dataset.searchOpen = 'true';
      headerWrapper.classList.add('header-wrapper--scrolled');
      headerElement.classList.add('header--mega-menu-open', 'header--predictive-search-open');
    }
  }

  // Header Buttons Drawer + Menu Drawer - header classes for drawer states
  function initHeaderButtonsDrawer() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const headerElement = headerWrapper ? headerWrapper.querySelector('.header') : null;
    if (!headerWrapper || !headerElement) return;

    function isMenuDrawerOpen() {
      return !!document.querySelector('.menu-drawer-container[open]');
    }
    function isButtonsDrawerOpen() {
      return isHeaderButtonsDrawerOpen();
    }
    function isMegaMenuOpen() {
      return headerWrapper.dataset.megaMenuOpen === 'true' || !!document.querySelector('.mega-menu--custom[open], .mega-menu[open], details.mega-menu[open]');
    }
    function syncDrawerClasses() {
      var menuOpen = isMenuDrawerOpen();
      var buttonsOpen = isButtonsDrawerOpen();
      var megaOpen = isMegaMenuOpen();
      headerElement.classList.toggle('header--menu-drawer-open', menuOpen);
      headerElement.classList.toggle('header--buttons-drawer-open', buttonsOpen);
      headerElement.classList.toggle('header--menu-drawer-and-buttons-drawer-open', menuOpen && buttonsOpen);
      headerElement.classList.toggle('header--buttons-drawer-only-open', buttonsOpen && !menuOpen && !megaOpen);
    }

    // Menu drawer (hamburger) - add header--menu-drawer-open, header--menu-drawer-and-buttons-drawer-open
    var menuDrawerContainer = document.querySelector('.menu-drawer-container');
    if (menuDrawerContainer) {
      menuDrawerContainer.addEventListener('toggle', function() {
        if (menuDrawerContainer.open) {
          headerWrapper.classList.add('header-wrapper--scrolled');
          headerElement.classList.add('header--mega-menu-open', 'header--menu-drawer-open');

          // When main menu drawer opens, hide sticky collection filters bar
          document.querySelectorAll('.filters-stikcy-wrapper-bd-collection-page--in-grid').forEach(function(barEl) {
            barEl.classList.remove('filters-stikcy-wrapper-bd-collection-page--in-grid');
          });

          if (isButtonsDrawerOpen()) {
            headerElement.classList.add('header--menu-drawer-and-buttons-drawer-open');
            headerElement.classList.remove('header--buttons-drawer-only-open');
          }
        } else {
          headerElement.classList.remove('header--menu-drawer-open', 'header--menu-drawer-and-buttons-drawer-open');
          if (!isButtonsDrawerOpen() && !isMegaMenuOpen()) {
            var searchModal = document.querySelector('details-modal.header__search');
            var searchDetails = searchModal ? searchModal.querySelector('details') : null;
            if (!searchDetails || !searchDetails.hasAttribute('open')) {
              headerElement.classList.remove('header--mega-menu-open');
            }
          }
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (!isButtonsDrawerOpen() && !isMegaMenuOpen() && scrollTop <= 50) {
            headerWrapper.classList.remove('header-wrapper--scrolled');
          }

          // When menu drawer fully closes and no other overlays are open,
          // restore sticky filters bar visibility (IntersectionObserver will keep managing it)
          if (!isButtonsDrawerOpen() && !isMegaMenuOpen()) {
            var bar = document.querySelector('.filters-stikcy-wrapper-bd-collection-page');
            if (bar) {
              bar.classList.add('filters-stikcy-wrapper-bd-collection-page--in-grid');
            }
          }
        }
      });
    }

    const drawers = document.querySelectorAll('.header-buttons-drawer');
    if (!drawers.length && !menuDrawerContainer) return;

    var durationMs = 300;
    try {
      var durationMatch = getComputedStyle(document.documentElement).getPropertyValue('--duration-default').trim();
      if (durationMatch && durationMatch.endsWith('ms')) durationMs = parseInt(durationMatch, 10) || 300;
      else if (durationMatch && durationMatch.endsWith('s')) durationMs = (parseFloat(durationMatch) || 0.3) * 1000;
    } catch (e) {}

    function closeHeaderButtonsDrawerAnimated(detailsEl) {
      if (!detailsEl.hasAttribute('open') || detailsEl.classList.contains('header-buttons-drawer--closing')) return;
      detailsEl.classList.remove('header-buttons-drawer--opening');
      detailsEl.classList.add('header-buttons-drawer--closing');
      var panel = detailsEl.querySelector('.header-buttons-drawer__panel');
      var done = false;
      function doClose() {
        if (done) return;
        done = true;
        detailsEl.classList.remove('header-buttons-drawer--closing');
        detailsEl.removeAttribute('open');
      }
      if (panel) {
        panel.addEventListener('transitionend', function once(e) {
          if (e.target !== panel || e.propertyName !== 'transform') return;
          panel.removeEventListener('transitionend', once);
          doClose();
        });
        setTimeout(doClose, durationMs + 100);
      } else {
        doClose();
      }
    }

    drawers.forEach(function(details) {
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function(e) {
          if (!e.isTrusted || details.hasAttribute('open')) return;
          syncHeaderButtonsDrawerLayout();
        }, true);

        function preventCloseIfOpen(e) {
          if (!details.hasAttribute('open') || !e.isTrusted) return;
          e.preventDefault();
          e.stopPropagation();
        }
        summary.addEventListener('click', preventCloseIfOpen, true);
      }

      details.addEventListener('toggle', function() {
        if (details.open) {
          details.classList.remove('header-buttons-drawer--closing');
          ensureHeaderButtonsDrawerLayoutMaintainer();
          syncHeaderButtonsDrawerLayout();
          lockHeaderButtonsDrawerScroll();
          syncHeaderButtonsDrawerLayout();
          headerWrapper.classList.add('header-wrapper--scrolled');
          headerWrapper.dataset.drawerOpen = 'true';
          headerElement.classList.add('header--mega-menu-open', 'header--buttons-drawer-open');

          // When Konfigurator drawer opens, hide sticky collection filters bar
          document.querySelectorAll('.filters-stikcy-wrapper-bd-collection-page--in-grid').forEach(function(barEl) {
            barEl.classList.remove('filters-stikcy-wrapper-bd-collection-page--in-grid');
          });

          // If header search modal is open, close it when the buttons drawer opens
          (function() {
            const searchModal = document.querySelector('details-modal.header__search');
            const searchDetails = searchModal ? searchModal.querySelector('details') : null;
            if (searchDetails && searchDetails.hasAttribute('open')) {
              searchDetails.removeAttribute('open');
            }
          })();
          if (isMenuDrawerOpen()) {
            headerElement.classList.add('header--menu-drawer-and-buttons-drawer-open');
            headerElement.classList.remove('header--buttons-drawer-only-open');
          } else if (isMegaMenuOpen()) {
            headerElement.classList.remove('header--buttons-drawer-only-open');
            headerElement.classList.add('header--mega-menu-and-buttons-drawer-open');
          } else {
            headerElement.classList.add('header--buttons-drawer-only-open');
          }
          requestAnimationFrame(function() {
            details.classList.add('header-buttons-drawer--opening');
            syncHeaderButtonsDrawerLayout();
            requestAnimationFrame(syncHeaderButtonsDrawerLayout);
          });
          requestAnimationFrame(function() {
            if (isMegaMenuOpen() && isButtonsDrawerOpen()) {
              headerElement.classList.remove('header--buttons-drawer-only-open');
              headerElement.classList.add('header--mega-menu-and-buttons-drawer-open');
            }
            if (isMenuDrawerOpen() && isButtonsDrawerOpen()) {
              headerElement.classList.add('header--menu-drawer-and-buttons-drawer-open');
              headerElement.classList.remove('header--buttons-drawer-only-open');
            }
            if (isButtonsDrawerOpen() && !isMenuDrawerOpen() && !isMegaMenuOpen()) {
              headerElement.classList.add('header--buttons-drawer-only-open');
            }
          });
        } else {
          details.classList.remove('header-buttons-drawer--opening', 'header-buttons-drawer--closing');
          headerWrapper.removeAttribute('data-drawer-open');

          // If no header buttons drawers are open, remove body overflow and header classes
          const anyDrawerOpen = Array.from(drawers).some(function(d) { return d.open; });
          if (!anyDrawerOpen) {
            headerElement.classList.remove('header--buttons-drawer-open', 'header--mega-menu-and-buttons-drawer-open', 'header--buttons-drawer-only-open', 'header--menu-drawer-and-buttons-drawer-open');
            unlockHeaderButtonsDrawerScroll();
            releaseHeaderButtonsDrawerHidePrevention();
            document.body.classList.remove('overflow-hidden');

            // When Konfigurator drawer fully closes and no other overlays are open, restore sticky filters bar
            if (!isMenuDrawerOpen() && !isMegaMenuOpen()) {
              var filtersBar = document.querySelector('.filters-stikcy-wrapper-bd-collection-page');
              if (filtersBar) {
                filtersBar.classList.add('filters-stikcy-wrapper-bd-collection-page--in-grid');
              }
            }

            // Defer so that if the same click opened predictive search, we see it and don't remove the class
            (function() {
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  const searchModal = document.querySelector('details-modal.header__search');
                  const searchDetails = searchModal ? searchModal.querySelector('details') : null;
                  const isPredictiveSearchOpen = searchDetails && searchDetails.hasAttribute('open');
                  const hasMegaMenuOpen = headerWrapper.dataset.megaMenuOpen === 'true';
                  if (!hasMegaMenuOpen && !isPredictiveSearchOpen && !isMenuDrawerOpen()) {
                    headerElement.classList.remove('header--mega-menu-open');
                  }
                });
              });
            })();
          }

          // Defer scrolled-state check until after scroll lock is released so we read the real scroll position
          requestAnimationFrame(function() {
            const hasMegaMenuOpen = headerWrapper.dataset.megaMenuOpen === 'true';
            const hasMegaMenuOpenInDom = !!document.querySelector('.mega-menu--custom[open], .mega-menu[open], details.mega-menu[open]');
            const hasSearchOpen = headerWrapper.dataset.searchOpen === 'true';
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!hasMegaMenuOpen && !hasMegaMenuOpenInDom && !hasSearchOpen && !isMenuDrawerOpen() && !isButtonsDrawerOpen() && scrollTop <= 50) {
              headerWrapper.classList.remove('header-wrapper--scrolled');
            }
          });
        }
      });
    });

    // When any mega menu (including default .mega-menu) opens, remove buttons-drawer classes if drawer is not open
    document.querySelectorAll('details.mega-menu:not(.mega-menu--custom)').forEach(function(megaMenu) {
      megaMenu.addEventListener('toggle', function() {
        if (megaMenu.open) {
          headerWrapper.dataset.megaMenuOpen = 'true';
          if (headerElement && !document.querySelector('.header-buttons-drawer[open]')) {
            headerElement.classList.remove('header--buttons-drawer-open', 'header--buttons-drawer-only-open');
          }
        } else {
          if (!document.querySelector('.mega-menu--custom[open], .mega-menu[open], details.mega-menu[open]')) {
            headerWrapper.removeAttribute('data-mega-menu-open');
            if (headerElement && !document.querySelector('.header-buttons-drawer[open]')) {
              headerElement.classList.remove('header--buttons-drawer-open', 'header--buttons-drawer-only-open');
            }
          }
        }
      });
    });

    // Close drawer when clicking outside, or when clicking the overlay (details::after); don't close when clicking on the header bar
    document.addEventListener('click', function(e) {
      const openDrawer = document.querySelector('.header-buttons-drawer[open]');
      if (!openDrawer) return;

      if (e.target.closest('[data-open-header-buttons-drawer]')) return;

      if (Date.now() < headerButtonsDrawerExternalOpenUntil) return;

      const clickOnOverlay = e.target === openDrawer;
      const clickInsideHeader = headerWrapper && headerWrapper.contains(e.target);
      if (clickInsideHeader && !clickOnOverlay) return;

      const panel = openDrawer.querySelector('.header-buttons-drawer__panel');
      const clickInsidePanel = panel && panel.contains(e.target);
      const clickInsideDrawer = openDrawer.contains(e.target);

      // If click is completely outside the drawer, or inside the drawer but not inside the panel (overlay area),
      // close the drawer with same animation as menu-drawer
      if (!clickInsideDrawer || (clickInsideDrawer && !clickInsidePanel)) {
        closeHeaderButtonsDrawerAnimated(openDrawer);
      }
    });

    // Close header-buttons-drawer when the dedicated close button is clicked
    headerElement.querySelectorAll('.header__buttons-drawer-close').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var openDrawer = document.querySelector('.header-buttons-drawer[open]');
        if (openDrawer) closeHeaderButtonsDrawerAnimated(openDrawer);
      });
    });

    if (!document.documentElement.dataset.headerButtonsDrawerScrollBound) {
      document.documentElement.dataset.headerButtonsDrawerScrollBound = 'true';
      document.addEventListener('touchmove', preventHeaderButtonsDrawerBackgroundScroll, { passive: false });
      document.addEventListener('wheel', preventHeaderButtonsDrawerBackgroundScroll, { passive: false });
    }

    // Sync classes on init in case a drawer is already open
    requestAnimationFrame(syncDrawerClasses);
  }

  // Apply a card variant's metafield image to the product card media
  function applyCardVariantImage(cardWrapper, variant) {
    if (!cardWrapper || !variant) return;
    const img = cardWrapper.querySelector('img[data-product-card-image]');
    if (!img) return;
    if (variant.imageSrc) {
      img.src = variant.imageSrc;
      if (cardWrapper.hasAttribute('data-default-src')) {
        cardWrapper.setAttribute('data-default-src', variant.imageSrc);
      }
    }
    if (variant.imageSrcset) {
      img.srcset = variant.imageSrcset;
      if (cardWrapper.hasAttribute('data-default-srcset')) {
        cardWrapper.setAttribute('data-default-srcset', variant.imageSrcset);
      }
    } else if (variant.imageSrc) {
      img.srcset = variant.imageSrc + ' 1x';
      if (cardWrapper.hasAttribute('data-default-srcset')) {
        cardWrapper.setAttribute('data-default-srcset', variant.imageSrc + ' 1x');
      }
    }
    if (variant.imageAlt != null) img.alt = variant.imageAlt;
  }

  // Update card price + compare-at to match the selected variant (bd-price markup)
  function applyCardVariantPrice(cardWrapper, variant) {
    if (!cardWrapper || !variant) return;
    if (variant.priceFormatted == null && variant.price == null) return;
    var priceRoot = cardWrapper.querySelector('[data-card-price] .price') || cardWrapper.querySelector('.card-information .price');
    if (!priceRoot) return;

    var priceFormatted = variant.priceFormatted != null ? String(variant.priceFormatted) : '';
    var compareFormatted = variant.compareAtPriceFormatted != null ? String(variant.compareAtPriceFormatted) : '';
    var price = Number(variant.price) || 0;
    var compareAt = Number(variant.compareAtPrice) || 0;
    var onSale = compareAt > price;

    priceRoot.classList.toggle('price--on-sale', onSale);

    var regularItem = priceRoot.querySelector('.price__regular .price-item--regular');
    if (regularItem && priceFormatted) regularItem.textContent = priceFormatted;

    var compareItem = priceRoot.querySelector('.price__sale .price-item--compare-at');
    if (compareItem && compareFormatted) compareItem.textContent = compareFormatted;

    var saleItem = priceRoot.querySelector('.price__sale .text--xxs');
    if (saleItem && priceFormatted) saleItem.textContent = priceFormatted;
  }

  function applyCardVariant(cardWrapper, variant) {
    if (!cardWrapper || !variant) return;
    applyCardVariantImage(cardWrapper, variant);
    applyCardVariantPrice(cardWrapper, variant);
  }

  function ensureColorSwatchConfig() {
    if (window.bdColorSwatchConfig) return window.bdColorSwatchConfig;
    var el = document.getElementById('bd-color-swatch-config');
    if (!el) {
      window.bdColorSwatchConfig = {};
      return window.bdColorSwatchConfig;
    }
    try {
      window.bdColorSwatchConfig = JSON.parse(el.textContent || '{}') || {};
    } catch (err) {
      window.bdColorSwatchConfig = {};
    }
    return window.bdColorSwatchConfig;
  }

  function getMaterialValueFromCard(cardWrapper) {
    if (!cardWrapper) return '';
    var materialVal = '';
    cardWrapper.querySelectorAll('.product-card__option-switcher').forEach(function(sw) {
      var name = String(sw.getAttribute('data-option-name') || '').toLowerCase();
      if (name === 'material' || name.indexOf('material') !== -1) {
        materialVal = sw.getAttribute('data-current-value') || '';
      }
    });
    return materialVal;
  }

  function lookupColorSwatchConfigEntry(material, color, opts) {
    var config = ensureColorSwatchConfig();
    var colorKey = String(color || '').toLowerCase().trim();
    var materialKey = String(material || '').toLowerCase().trim();
    var materialOnly = opts && opts.materialOnly;
    var keys = [];
    if (materialKey && colorKey) {
      keys.push(materialKey + ' / ' + colorKey);
      keys.push(materialKey + '/' + colorKey);
      keys.push(materialKey + '-' + colorKey);
    }
    // When material is known (e.g. after Material switch), do not fall back to
    // color-only config — that kept the same swatch image across materials.
    if (colorKey && (!materialOnly || !materialKey)) keys.push(colorKey);
    for (var i = 0; i < keys.length; i++) {
      if (config[keys[i]]) return config[keys[i]];
    }
    return null;
  }

  function applyConfigSwatchVisual(btn, material, opts) {
    if (!btn) return false;
    var entry = lookupColorSwatchConfigEntry(material, btn.getAttribute('data-option-value'), opts);
    if (!entry || !entry.value) return false;
    var swatchEl = btn.querySelector('.swatch');
    if (!swatchEl) return false;
    if (entry.type === 'image') {
      var bg = "url('" + entry.value + "')";
      swatchEl.style.setProperty('--swatch--background', bg);
      swatchEl.style.setProperty('--swatch--background-image', bg);
      swatchEl.style.backgroundImage = bg;
      swatchEl.style.removeProperty('background-color');
      swatchEl.style.removeProperty('--swatch--background-color');
      swatchEl.classList.remove('swatch--unavailable');
      return true;
    }
    if (entry.type === 'color') {
      swatchEl.style.setProperty('--swatch--background', entry.value);
      swatchEl.style.setProperty('--swatch--background-color', entry.value);
      swatchEl.style.backgroundColor = entry.value;
      swatchEl.style.removeProperty('background-image');
      swatchEl.style.removeProperty('--swatch--background-image');
      swatchEl.classList.remove('swatch--unavailable');
      return true;
    }
    return false;
  }

  function applyVariantImageToSwatch(btn, imageSrc) {
    if (!btn || !imageSrc) return;
    var swatchEl = btn.querySelector('.swatch');
    if (!swatchEl) return;
    var bg = "url('" + imageSrc + "')";
    swatchEl.style.setProperty('--swatch--background', bg);
    swatchEl.style.setProperty('--swatch--background-image', bg);
    swatchEl.style.backgroundImage = bg;
    swatchEl.style.removeProperty('background-color');
    swatchEl.style.removeProperty('--swatch--background-color');
    swatchEl.classList.remove('swatch--unavailable');
  }

  // Keep color swatch image/variant data aligned with current non-color option selection
  function updateColorSwatchImagesForSelection(cardWrapper, selection, colorOptionPosition) {
    if (!cardWrapper || !cardWrapper.cardVariants || !colorOptionPosition) return;
    const fieldset = cardWrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
    if (!fieldset) return;
    const variants = cardWrapper.cardVariants;
    const materialVal = getMaterialValueFromCard(cardWrapper);
    fieldset.querySelectorAll('.card__color-swatch-btn').forEach(function(b) {
      const colorVal = b.getAttribute('data-option-value');
      if (colorVal == null) return;
      const sel = {
        1: selection[1],
        2: selection[2],
        3: selection[3]
      };
      sel[colorOptionPosition] = colorVal;

      // Prefer exact match for current material/options + this Farbe.
      // Never fall back to another material's color variant (that kept stale images).
      var match = findVariantMatchingSelection(variants, sel);
      if (!match) {
        match = variants.find(function(v) {
          var colorOpt = colorOptionPosition === 1 ? v.option1 : (colorOptionPosition === 2 ? v.option2 : v.option3);
          if (colorOpt !== colorVal) return false;
          for (var p = 1; p <= 3; p++) {
            if (p === colorOptionPosition) continue;
            var s = selection[p];
            if (s == null || s === '') continue;
            var opt = p === 1 ? v.option1 : (p === 2 ? v.option2 : v.option3);
            if (opt !== s) return false;
          }
          return true;
        });
      }
      if (!match) return;

      b.setAttribute('data-variant-id', String(match.id));
      if (match.imageSrc) {
        b.setAttribute('data-image-src', match.imageSrc);
        b.setAttribute('data-image-srcset', match.imageSrcset || (match.imageSrc + ' 1x'));
        applyVariantImageToSwatch(b, match.imageSrc);
      }
      if (match.imageAlt != null) b.setAttribute('data-image-alt', match.imageAlt);
      // Prefer material+color config when present; keep variant image otherwise
      applyConfigSwatchVisual(b, materialVal, { materialOnly: true });
    });
  }

  // Ensure cardVariants JSON is parsed onto the card wrapper
  function ensureCardVariants(cardWrapper) {
    if (!cardWrapper) return null;
    if (cardWrapper.cardVariants) return cardWrapper.cardVariants;
    const scriptEl = cardWrapper.querySelector('script[data-card-variants]');
    if (!scriptEl) return null;
    try {
      cardWrapper.cardVariants = JSON.parse(scriptEl.textContent || '[]');
    } catch (err) {
      return null;
    }
    return cardWrapper.cardVariants;
  }

  // Shopify-like handleize for matching filter.v.option.<handle> to option names
  function handleizeOptionName(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Active collection facet filters like filter.v.option.ausrichtung=Rechts
  function getActiveVariantOptionFilters() {
    var filters = [];
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function(value, key) {
        var match = key.match(/^filter\.v\.option\.(.+)$/i);
        if (!match || value == null || value === '') return;
        filters.push({ handle: String(match[1]).toLowerCase(), value: value });
      });
    } catch (err) {}
    return filters;
  }

  // Apply active URL option filters to card switchers / color swatches before availability sync
  function applyActiveFiltersToCard(cardWrapper) {
    if (!cardWrapper) return;
    var filters = getActiveVariantOptionFilters();
    if (!filters.length) return;

    filters.forEach(function(filter) {
      cardWrapper.querySelectorAll('.product-card__option-switcher').forEach(function(sw) {
        var name = sw.getAttribute('data-option-name') || '';
        if (handleizeOptionName(name) !== filter.handle) return;
        var values = (sw.getAttribute('data-values') || '').split('|||');
        var matchVal = null;
        for (var i = 0; i < values.length; i++) {
          if (values[i] === filter.value || String(values[i]).toLowerCase() === String(filter.value).toLowerCase()) {
            matchVal = values[i];
            break;
          }
        }
        if (!matchVal) return;
        sw.setAttribute('data-current-value', matchVal);
        var valueEl = sw.querySelector('.product-card__option-switcher-value');
        if (valueEl) valueEl.textContent = matchVal;
        sw.setAttribute('aria-label', name + ': ' + matchVal + '. Click for next value');
      });

      var fieldset = cardWrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
      if (!fieldset) return;
      var colorName = fieldset.getAttribute('aria-label') || '';
      if (handleizeOptionName(colorName) !== filter.handle) return;
      var matchedBtn = null;
      fieldset.querySelectorAll('.card__color-swatch-btn').forEach(function(b) {
        var val = b.getAttribute('data-option-value');
        var isMatch = val === filter.value || String(val || '').toLowerCase() === String(filter.value).toLowerCase();
        b.classList.toggle('is-selected', isMatch);
        b.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
        if (isMatch) matchedBtn = b;
      });
      if (matchedBtn) {
        var variants = ensureCardVariants(cardWrapper);
        var variantId = parseInt(matchedBtn.getAttribute('data-variant-id'), 10);
        if (variants && !isNaN(variantId)) {
          var variant = variants.find(function(v) { return v.id === variantId; });
          if (variant) applyCardVariant(cardWrapper, variant);
        } else if (matchedBtn.getAttribute('data-image-src')) {
          var img = cardWrapper.querySelector('img[data-product-card-image]');
          if (img) {
            img.src = matchedBtn.getAttribute('data-image-src');
            img.srcset = matchedBtn.getAttribute('data-image-srcset') || img.src + ' 1x';
            if (matchedBtn.getAttribute('data-image-alt') != null) img.alt = matchedBtn.getAttribute('data-image-alt');
          }
        }
      }
    });
  }

  function updateSwatchListScrollableState(cardWrapper) {
    var wrapper = cardWrapper.querySelector('.product-card__swatch-list-wrapper');
    if (!wrapper) return;
    var visibleCount = wrapper.querySelectorAll('.card__color-swatch-btn:not(.is-unavailable)').length;
    wrapper.setAttribute('data-swatch-count', String(visibleCount));
    if (visibleCount > 4) wrapper.classList.add('product-card__swatch-list-wrapper--scrollable');
    else wrapper.classList.remove('product-card__swatch-list-wrapper--scrollable');
  }

  // Re-sync all product cards (initial load, facet AJAX, load-more). Exposed for facets.js.
  function syncProductCardAvailableOptions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.card-wrapper').forEach(function(cardWrapper) {
      if (!cardWrapper.querySelector('script[data-card-variants]')) return;
      // Fresh parse after AJAX replace (old cardVariants must not stick to detached nodes)
      cardWrapper.cardVariants = null;
      if (!ensureCardVariants(cardWrapper)) return;
      if (!cardWrapper.cardVariants.length) return;
      if (!cardWrapper.querySelector('.card__color-swatch-btn') && !cardWrapper.querySelector('.product-card__option-switcher')) return;
      applyActiveFiltersToCard(cardWrapper);
      syncAvailableOptions(cardWrapper);
      updateSwatchListScrollableState(cardWrapper);
    });
  }
  window.syncProductCardAvailableOptions = syncProductCardAvailableOptions;

  function updateSwatchSelectedName(cardWrapper, colorName) {
    if (!cardWrapper || colorName == null || colorName === '') return;
    var nameEl = cardWrapper.querySelector('[data-swatch-selected-name]');
    if (nameEl) nameEl.textContent = colorName;
  }

  // Product card color swatches: on swatch click, update the card's main image to the selected variant image
  function initProductCardSwatches() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.card__color-swatch-btn');
      if (!btn) return;
      const cardWrapper = btn.closest('.card-wrapper');
      if (!cardWrapper) return;
      const img = cardWrapper.querySelector('img[data-product-card-image]');
      if (!img) return;
      const fieldset = btn.closest('fieldset');
      if (fieldset) {
        fieldset.querySelectorAll('.card__color-swatch-btn').forEach(function(b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      }
      updateSwatchSelectedName(cardWrapper, btn.getAttribute('data-option-value'));
      const variants = ensureCardVariants(cardWrapper);
      const colorOptionPosition = fieldset ? parseInt(fieldset.getAttribute('data-option-position'), 10) : 0;
      let appliedVariant = null;
      if (variants && variants.length && colorOptionPosition >= 1 && colorOptionPosition <= 3) {
        const selection = getCurrentSelectionFromCard(cardWrapper, colorOptionPosition);
        const colorVal = btn.getAttribute('data-option-value');
        if (colorVal != null) selection[colorOptionPosition] = colorVal;
        appliedVariant = findVariantMatchingSelection(variants, selection);
      }
      if (!appliedVariant) {
        const variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (variants && !isNaN(variantId)) {
          appliedVariant = variants.find(function(v) { return v.id === variantId; });
        }
      }
      if (appliedVariant) {
        applyCardVariant(cardWrapper, appliedVariant);
        syncOptionSwitchersToVariant(cardWrapper, appliedVariant.id);
        syncAvailableOptions(cardWrapper);
      } else {
        const src = btn.getAttribute('data-image-src');
        const srcset = btn.getAttribute('data-image-srcset');
        const alt = btn.getAttribute('data-image-alt');
        if (src) img.src = src;
        if (srcset) img.srcset = srcset;
        if (alt !== null) img.alt = alt;
        const variantId = btn.getAttribute('data-variant-id');
        if (variantId && variants) {
          const fallbackVariant = variants.find(function(v) { return v.id === parseInt(variantId, 10); });
          if (fallbackVariant) applyCardVariantPrice(cardWrapper, fallbackVariant);
          syncOptionSwitchersToVariant(cardWrapper, parseInt(variantId, 10));
          syncAvailableOptions(cardWrapper);
        }
      }
    });
  }

  // Sync option switcher labels to a variant's option values (e.g. after color swatch click)
  function syncOptionSwitchersToVariant(cardWrapper, variantId) {
    const variants = cardWrapper.cardVariants;
    if (!variants || !variantId) return;
    const v = variants.find(function(x) { return x.id === variantId; });
    if (!v) return;
    const switchers = cardWrapper.querySelectorAll('.product-card__option-switcher');
    switchers.forEach(function(sw) {
      const pos = parseInt(sw.getAttribute('data-option-position'), 10);
      const val = pos === 1 ? v.option1 : (pos === 2 ? v.option2 : v.option3);
      if (val == null) return;
      const valueEl = sw.querySelector('.product-card__option-switcher-value');
      if (valueEl) valueEl.textContent = val;
      sw.setAttribute('data-current-value', val);
      const name = sw.getAttribute('data-option-name') || '';
      sw.setAttribute('aria-label', name + ': ' + val + '. Click for next value');
    });
  }

  // Return available option values for one option position given current selection (from variants)
  function getAvailableValuesForOption(variants, optionPosition, currentSelection) {
    const result = [];
    const seen = {};
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      let match = true;
      for (let p = 1; p <= 3; p++) {
        if (p === optionPosition) continue;
        const sel = currentSelection[p];
        const optVal = p === 1 ? v.option1 : (p === 2 ? v.option2 : v.option3);
        if (sel != null && sel !== '' && optVal !== sel) {
          match = false;
          break;
        }
      }
      if (!match) continue;
      const val = optionPosition === 1 ? v.option1 : (optionPosition === 2 ? v.option2 : v.option3);
      if (val != null && val !== '' && !seen[val]) {
        seen[val] = true;
        result.push(val);
      }
    }
    return result;
  }

  // Reorder Farbe swatches to match variant order for the current material/option selection
  function reorderColorSwatchesByValues(fieldset, orderedValues) {
    if (!fieldset || !orderedValues || !orderedValues.length) return;
    var buttons = Array.prototype.slice.call(fieldset.querySelectorAll('.card__color-swatch-btn'));
    if (!buttons.length) return;

    var byValue = {};
    buttons.forEach(function(btn) {
      var val = btn.getAttribute('data-option-value');
      if (val != null && byValue[val] == null) byValue[val] = btn;
    });

    var placed = {};
    orderedValues.forEach(function(val) {
      if (byValue[val]) {
        fieldset.appendChild(byValue[val]);
        placed[val] = true;
      }
    });

    // Keep unavailable / remaining swatches after the ordered available ones
    buttons.forEach(function(btn) {
      var val = btn.getAttribute('data-option-value');
      if (val == null || placed[val]) return;
      fieldset.appendChild(btn);
    });
  }

  // Get current selection from card DOM (option position -> value)
  function getCurrentSelectionFromCard(cardWrapper, colorOptionPosition) {
    const sel = { 1: null, 2: null, 3: null };
    const fieldset = cardWrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
    if (fieldset && colorOptionPosition >= 1 && colorOptionPosition <= 3) {
      const selectedSwatch = fieldset.querySelector('.card__color-swatch-btn.is-selected, .card__color-swatch-btn[aria-pressed="true"]');
      if (selectedSwatch) {
        const val = selectedSwatch.getAttribute('data-option-value');
        if (val != null) sel[colorOptionPosition] = val;
      }
    }
    cardWrapper.querySelectorAll('.product-card__option-switcher').forEach(function(sw) {
      const pos = parseInt(sw.getAttribute('data-option-position'), 10);
      if (pos >= 1 && pos <= 3) {
        const val = sw.getAttribute('data-current-value');
        if (val != null && val !== '') sel[pos] = val;
      }
    });
    return sel;
  }

  // Filter variants to those matching the given selection (null/empty means any)
  function findVariantMatchingSelection(variants, selection) {
    return variants.find(function(v) {
      for (let p = 1; p <= 3; p++) {
        const s = selection[p];
        if (s == null || s === '') continue;
        const opt = p === 1 ? v.option1 : (p === 2 ? v.option2 : v.option3);
        if (opt !== s) return false;
      }
      return true;
    });
  }

  // Best variant for an option change: exact combo first, else highest overlap on other options
  function findBestVariantForOptionChange(variants, selection, optionPos, nextVal) {
    if (!variants || !variants.length || !optionPos || nextVal == null) return null;
    const desired = {
      1: selection[1],
      2: selection[2],
      3: selection[3]
    };
    desired[optionPos] = nextVal;
    const exact = findVariantMatchingSelection(variants, desired);
    if (exact) return exact;

    let best = null;
    let bestScore = -1;
    variants.forEach(function(v) {
      const changedOpt = optionPos === 1 ? v.option1 : (optionPos === 2 ? v.option2 : v.option3);
      if (changedOpt !== nextVal) return;
      let score = 0;
      for (let p = 1; p <= 3; p++) {
        if (p === optionPos) continue;
        const s = desired[p];
        if (s == null || s === '') continue;
        const opt = p === 1 ? v.option1 : (p === 2 ? v.option2 : v.option3);
        if (opt === s) score += 2;
      }
      if (score > bestScore) {
        bestScore = score;
        best = v;
      }
    });
    return best;
  }

  // Show only available option values: hide unavailable swatches, limit switchers to available values
  function syncAvailableOptions(cardWrapper) {
    if (!ensureCardVariants(cardWrapper)) return;
    const variants = cardWrapper.cardVariants;
    if (!variants.length) return;
    const fieldset = cardWrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
    const colorOptionPosition = fieldset ? parseInt(fieldset.getAttribute('data-option-position'), 10) : 0;
    let selection = getCurrentSelectionFromCard(cardWrapper, colorOptionPosition);
    let match = findVariantMatchingSelection(variants, selection);
    if (!match) {
      // Prefer a variant that matches all non-color (switcher) options, any color
      match = variants.find(function(v) {
        for (var p = 1; p <= 3; p++) {
          if (p === colorOptionPosition) continue;
          var s = selection[p];
          if (s != null && s !== '') {
            var opt = p === 1 ? v.option1 : (p === 2 ? v.option2 : v.option3);
            if (opt !== s) return false;
          }
        }
        return true;
      });
      if (!match) match = variants[0];
      selection = {
        1: match.option1,
        2: match.option2,
        3: match.option3
      };
      syncOptionSwitchersToVariant(cardWrapper, match.id);
      if (fieldset && colorOptionPosition >= 1 && colorOptionPosition <= 3) {
        const selVal = selection[colorOptionPosition];
        fieldset.querySelectorAll('.card__color-swatch-btn').forEach(function(b) {
          const isSelected = b.getAttribute('data-option-value') === selVal;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        updateSwatchSelectedName(cardWrapper, selVal);
      }
    }
    // Always sync card media/price to the resolved selection (fixes Ausrichtung etc.)
    if (match) applyCardVariant(cardWrapper, match);
    if (colorOptionPosition >= 1 && colorOptionPosition <= 3) {
      updateColorSwatchImagesForSelection(cardWrapper, selection, colorOptionPosition);
      if (selection[colorOptionPosition]) {
        updateSwatchSelectedName(cardWrapper, selection[colorOptionPosition]);
      }
    }
    for (let pos = 1; pos <= 3; pos++) {
      const available = getAvailableValuesForOption(variants, pos, selection);
      if (pos === colorOptionPosition && fieldset) {
        fieldset.querySelectorAll('.card__color-swatch-btn').forEach(function(b) {
          const val = b.getAttribute('data-option-value');
          const isAvailable = val != null && available.indexOf(val) !== -1;
          b.classList.toggle('is-unavailable', !isAvailable);
          b.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
        });
        reorderColorSwatchesByValues(fieldset, available);
        // Refresh images after reorder so each Farbe uses the current material's variant
        updateColorSwatchImagesForSelection(cardWrapper, selection, colorOptionPosition);
        updateSwatchListScrollableState(cardWrapper);
      } else {
        // Keep all option values in switcher (do not restrict to available only) so user can cycle through every material/option
        cardWrapper.querySelectorAll('.product-card__option-switcher[data-option-position="' + pos + '"]').forEach(function(sw) {
          // Only sync displayed value from current selection; do not overwrite data-values
          const currentVal = sw.getAttribute('data-current-value');
          const valueEl = sw.querySelector('.product-card__option-switcher-value');
          const targetVal = pos === 1 ? selection[1] : (pos === 2 ? selection[2] : selection[3]);
          if (targetVal != null && targetVal !== '' && targetVal !== currentVal) {
            sw.setAttribute('data-current-value', targetVal);
            if (valueEl) valueEl.textContent = targetVal;
            const name = sw.getAttribute('data-option-name') || '';
            sw.setAttribute('aria-label', name + ': ' + targetVal + '. Click for next value');
          }
        });
      }
    }
  }

  // Product card option switchers: click cycles to next option value and updates card image
  function initProductCardOptionSwitchers() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.product-card__option-switcher');
      if (!btn) return;
      if (btn.classList.contains('product-card__product-switcher')) return;
      const cardWrapper = btn.closest('.card-wrapper');
      if (!cardWrapper) return;
      const variants = ensureCardVariants(cardWrapper);
      if (!variants || !variants.length) return;
      const img = cardWrapper.querySelector('img[data-product-card-image]');
      if (!img) return;
      const optionPos = parseInt(btn.getAttribute('data-option-position'), 10);
      if (!(optionPos >= 1 && optionPos <= 3)) return;
      const valuesStr = btn.getAttribute('data-values');
      if (!valuesStr) return;
      const values = valuesStr.split('|||');
      if (!values.length) return;
      const currentVal = btn.getAttribute('data-current-value') || '';
      let currentIdx = values.indexOf(currentVal);
      if (currentIdx < 0) currentIdx = 0;
      const nextIdx = (currentIdx + 1) % values.length;
      const nextVal = values[nextIdx];

      // Use live switcher + Farbe selection — not stale swatch data-variant-id
      const fieldset = cardWrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
      const colorPos = fieldset ? parseInt(fieldset.getAttribute('data-option-position'), 10) : 0;
      const selection = getCurrentSelectionFromCard(cardWrapper, colorPos);
      let matchVariant = findBestVariantForOptionChange(variants, selection, optionPos, nextVal);
      if (!matchVariant) return;

      const valueEl = btn.querySelector('.product-card__option-switcher-value');
      if (valueEl) valueEl.textContent = nextVal;
      btn.setAttribute('data-current-value', nextVal);
      const name = btn.getAttribute('data-option-name') || '';
      btn.setAttribute('aria-label', name + ': ' + nextVal + '. Click for next value');
      syncOptionSwitchersToVariant(cardWrapper, matchVariant.id);
      if (fieldset && colorPos >= 1 && colorPos <= 3) {
        const colorVal = colorPos === 1 ? matchVariant.option1 : (colorPos === 2 ? matchVariant.option2 : matchVariant.option3);
        fieldset.querySelectorAll('.card__color-swatch-btn').forEach(function(b) {
          const isSelected = b.getAttribute('data-option-value') === colorVal;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        updateSwatchSelectedName(cardWrapper, colorVal);
      }
      // syncAvailableOptions applies the final matched variant image/price
      syncAvailableOptions(cardWrapper);
    });
  }

  // Update color swatches in the card to match the given product (from product JSON)
  function updateCardSwatchesForProduct(cardWrapper, product) {
    var fieldset = cardWrapper.querySelector('.product-card__swatch-list.card__color-swatches, .card__color-swatches');
    if (!fieldset) return;
    var options = product.options || [];
    var colorOptionIndex = -1;
    for (var i = 0; i < options.length; i++) {
      var name = (options[i] || '').toLowerCase();
      if (name === 'color' || name === 'colour' || name === 'farbe') {
        colorOptionIndex = i;
        break;
      }
    }
    var optionKey = colorOptionIndex >= 0 ? 'option' + (colorOptionIndex + 1) : null;
    if (optionKey == null || !product.variants || !product.variants.length) {
      fieldset.innerHTML = '';
      return;
    }
    var seen = {};
    var colorVariants = [];
    for (var j = 0; j < product.variants.length; j++) {
      var v = product.variants[j];
      var val = v[optionKey];
      if (val != null && val !== '' && !seen[val]) {
        seen[val] = true;
        var imgUrl = v.featured_image || product.featured_image || (product.images && product.images[0]);
        if (typeof imgUrl !== 'string' && imgUrl && imgUrl.src) imgUrl = imgUrl.src;
        if (typeof imgUrl === 'string' && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
        colorVariants.push({ value: val, variantId: v.id, imageSrc: imgUrl || '', imageAlt: product.title || val });
      }
    }
    if (!colorVariants.length) {
      fieldset.innerHTML = '';
      return;
    }
    var checkSvg = '<span class="card__color-swatch-check" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    var html = '';
    for (var k = 0; k < colorVariants.length; k++) {
      var item = colorVariants[k];
      var selected = k === 0;
      var swatchStyle = '';
      if (item.imageSrc) {
        try {
          var bgUrl = 'url(' + JSON.stringify(item.imageSrc) + ')';
          swatchStyle = ' style="--swatch--background: ' + bgUrl + '; --swatch--background-image: ' + bgUrl + '; background-image: ' + bgUrl + ';"';
        } catch (err) {
          var bgUrlFallback = 'url(\'' + (item.imageSrc || '').replace(/'/g, '&#39;') + '\')';
          swatchStyle = ' style="--swatch--background: ' + bgUrlFallback + '; --swatch--background-image: ' + bgUrlFallback + '; background-image: ' + bgUrlFallback + ';"';
        }
      }
      var swatchClass = 'swatch' + (item.imageSrc ? '' : ' swatch--unavailable');
      var esc = function(s) { return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      html += '<button type="button" class="card__color-swatch-btn' + (selected ? ' is-selected' : '') + '" aria-label="' + esc(item.value) + '" aria-pressed="' + (selected ? 'true' : 'false') + '" data-variant-id="' + item.variantId + '" data-option-value="' + esc(item.value) + '" data-image-src="' + esc(item.imageSrc) + '" data-image-srcset="' + esc(item.imageSrc) + ' 1x" data-image-alt="' + esc(item.imageAlt) + '">';
      html += '<span class="' + swatchClass + '"' + swatchStyle + '></span>';
      html += '<span class="card__color-swatch-tooltip" aria-hidden="true">' + esc(item.value) + '</span>';
      if (selected) html += checkSvg;
      html += '</button>';
    }
    fieldset.innerHTML = html;
    updateSwatchSelectedName(cardWrapper, colorVariants[0].value);
    var wrapper = cardWrapper.querySelector('.product-card__swatch-list-wrapper');
    if (wrapper) {
      wrapper.setAttribute('data-swatch-count', String(colorVariants.length));
      if (colorVariants.length > 4) wrapper.classList.add('product-card__swatch-list-wrapper--scrollable');
      else wrapper.classList.remove('product-card__swatch-list-wrapper--scrollable');
    }
    var img = cardWrapper.querySelector('img[data-product-card-image]');
    if (img && colorVariants[0].imageSrc) {
      img.src = colorVariants[0].imageSrc;
      img.srcset = colorVariants[0].imageSrc + ' 1x';
      img.alt = colorVariants[0].imageAlt;
    }
    if (cardWrapper.hasAttribute('data-default-src')) {
      cardWrapper.setAttribute('data-default-src', colorVariants[0].imageSrc || cardWrapper.getAttribute('data-default-src'));
      cardWrapper.setAttribute('data-default-srcset', (colorVariants[0].imageSrc ? colorVariants[0].imageSrc + ' 1x' : '') || cardWrapper.getAttribute('data-default-srcset') || '');
    }
  }

  // Collection page: change image view button – toggle default/list icon and swap card images
  document.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest && e.target.closest('.change-image-view-button-bd-collection-page');
    if (!btn) return;
    var gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;
    var isListViewed = btn.classList.toggle('is-list-view');
    btn.setAttribute('aria-pressed', isListViewed ? 'true' : 'false');
    var cards = gridContainer.querySelectorAll('.product-card-wrapper[data-list-view-src]');
    cards.forEach(function(card) {
      var img = card.querySelector('img[data-product-card-image]');
      if (!img) return;
      if (isListViewed) {
        var src = card.getAttribute('data-list-view-src');
        var srcset = card.getAttribute('data-list-view-srcset');
        if (src) img.src = src;
        if (srcset) img.srcset = srcset;
      } else {
        var defaultSrc = card.getAttribute('data-default-src');
        var defaultSrcset = card.getAttribute('data-default-srcset');
        if (defaultSrc) img.src = defaultSrc;
        if (defaultSrcset) img.srcset = defaultSrcset;
      }
    });
  });

  // Collection UGC slider: 4 slides per view, 8px gap, next button; story modal on slide click
  function initCollectionUgcSliders() {
    const sections = document.querySelectorAll('.bd-collection-ugc[data-section-id]');
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const swiperElement = document.getElementById('bd-collection-ugc-swiper-' + sectionId);
      if (!swiperElement) return;

      const nextBtn = section.querySelector('.bd-collection-ugc__nav-btn--next');
      if (!nextBtn) return;

      const modal = section.querySelector('.bd-collection-ugc-story-modal');
      const progressSegs = modal ? modal.querySelectorAll('.bd-collection-ugc-story-modal__progress-seg') : [];
      const slides = modal ? modal.querySelectorAll('.bd-collection-ugc-story-modal__slide') : [];
      const closeBtn = modal ? modal.querySelector('.bd-collection-ugc-story-modal__close') : null;
      const overlay = modal ? modal.querySelector('.bd-collection-ugc-story-modal__overlay') : null;
      const prevBtn = modal ? modal.querySelector('.bd-collection-ugc-story-modal__prev') : null;
      const nextModalBtn = modal ? modal.querySelector('.bd-collection-ugc-story-modal__next') : null;
      const blockContents = modal ? modal.querySelectorAll('.bd-collection-ugc-story-modal__block-content') : [];
      var showPrevNext = modal && modal.dataset.showPrevNext !== 'false';
      var autoAdvance = modal && modal.dataset.autoAdvance !== 'false';
      var enableVideoSound = section.dataset.enableVideoSound === 'true'
        || (modal && modal.dataset.enableVideoSound === 'true');
      var slidesPerViewMobile = parseFloat(section.dataset.slidesPerViewMobile) || 2.5;
      var slidesPerViewDesktop = parseFloat(section.dataset.slidesPerViewDesktop) || 4;
      var spaceBetweenMobile = parseInt(section.dataset.spaceBetweenMobile, 10) || 4;
      var spaceBetweenDesktop = parseInt(section.dataset.spaceBetweenDesktop, 10) || 8;

      var currentIndex = 0;
      var advanceTimer = null;

      function pauseAllModalVideos() {
        if (!modal) return;
        modal.querySelectorAll('.bd-collection-ugc-story-modal__video').forEach(function(v) {
          v.pause();
          v.onended = null;
        });
      }

      function updateProgressBars(activeIndex) {
        progressSegs.forEach(function(seg, idx) {
          seg.classList.toggle('bd-collection-ugc-story-modal__progress-seg--active', idx === activeIndex);
          var fill = seg.querySelector('.bd-collection-ugc-story-modal__progress-fill');
          if (!fill) return;
          fill.classList.remove('bd-collection-ugc-story-modal__progress-fill--filled', 'bd-collection-ugc-story-modal__progress-fill--active');
          fill.style.width = '';
          fill.style.transitionDuration = '';
          if (idx < activeIndex) {
            fill.classList.add('bd-collection-ugc-story-modal__progress-fill--filled');
            fill.style.width = '100%';
          } else if (idx === activeIndex) {
            fill.classList.add('bd-collection-ugc-story-modal__progress-fill--active');
            var dur = parseFloat(seg.dataset.duration) || 5;
            fill.style.transitionDuration = dur + 's';
            fill.offsetHeight;
            fill.style.width = '100%';
          }
        });
      }

      function goNext() {
        if (currentIndex + 1 < slides.length) {
          currentIndex++;
          goToSlide(currentIndex);
        } else {
          closeModal();
        }
      }

      function goPrev() {
        if (currentIndex > 0) {
          currentIndex--;
          goToSlide(currentIndex);
        }
      }

      function goToSlide(i) {
        if (advanceTimer) {
          clearTimeout(advanceTimer);
          advanceTimer = null;
        }
        pauseAllModalVideos();
        slides.forEach(function(s, idx) {
          s.classList.toggle('bd-collection-ugc-story-modal__slide--active', idx === i);
        });
        updateProgressBars(i);
        blockContents.forEach(function(bc, idx) {
          bc.hidden = (idx !== i);
        });
        var slide = slides[i];
        if (!slide) return;
        var isVideo = slide.dataset.isVideo === 'true';
        var video = slide.querySelector('.bd-collection-ugc-story-modal__video');
        var durationMs = parseInt(slide.dataset.durationMs, 10) || 5000;
        if (isVideo && video) {
          video.pause();
          video.currentTime = 0;
          if (autoAdvance) {
            video.onended = function() {
              goNext();
            };
          }
          playStoryModalVideo(video, function() {
            if (autoAdvance) advanceTimer = setTimeout(goNext, durationMs);
          }, enableVideoSound);
          prefetchAdjacentStoryVideos(slides, i);
        } else if (autoAdvance) {
          advanceTimer = setTimeout(goNext, durationMs);
        }
      }

      function openModal(startIndex) {
        if (!modal || startIndex < 0 || startIndex >= slides.length) return;
        currentIndex = startIndex;
        modal.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden');
        document.querySelectorAll('.facets-container.facets-container-drawer').forEach(function(el) {
          el.classList.add('facets-container-drawer--ugc-modal-open');
        });
        goToSlide(currentIndex);
      }

      function closeModal() {
        if (!modal) return;
        if (advanceTimer) {
          clearTimeout(advanceTimer);
          advanceTimer = null;
        }
        pauseAllModalVideos();
        modal.setAttribute('hidden', '');
        document.body.classList.remove('overflow-hidden');
        document.querySelectorAll('.facets-container.facets-container-drawer').forEach(function(el) {
          el.classList.remove('facets-container-drawer--ugc-modal-open');
        });
      }

      if (modal) {
        if (closeBtn) closeBtn.addEventListener('click', closeModal);
        if (overlay) overlay.addEventListener('click', closeModal);
        if (showPrevNext) {
          if (prevBtn) prevBtn.addEventListener('click', goPrev);
          if (nextModalBtn) nextModalBtn.addEventListener('click', goNext);
        }
        progressSegs.forEach(function(seg) {
          seg.addEventListener('click', function() {
            var idx = parseInt(seg.dataset.index, 10);
            if (!isNaN(idx) && idx >= 0 && idx < slides.length) {
              currentIndex = idx;
              goToSlide(currentIndex);
            }
          });
        });
        modal.addEventListener('keydown', function(e) {
          if (e.code === 'Escape') closeModal();
        });
        var ugcTrack = modal.querySelector('.bd-collection-ugc-story-modal__track');
        if (ugcTrack) initUgcStoryModalDragWheel(ugcTrack, goPrev, goNext);
        scheduleStoryModalVideoWarmup(modal);
      }

      section.querySelectorAll('.bd-collection-ugc__slide').forEach(function(sliderSlide) {
        sliderSlide.addEventListener('click', function(e) {
          if (e.target.closest('.bd-collection-ugc__nav-btn')) return;
          var index = parseInt(sliderSlide.dataset.ugcIndex, 10);
          if (!isNaN(index)) openModal(index);
        });
        sliderSlide.addEventListener('keydown', function(e) {
          if (e.code === 'Enter' || e.code === ' ') {
            e.preventDefault();
            var index = parseInt(sliderSlide.dataset.ugcIndex, 10);
            if (!isNaN(index)) openModal(index);
          }
        });
      });

      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }
        const swiper = new Swiper(swiperElement, {
          slidesPerView: slidesPerViewMobile,
          spaceBetween: spaceBetweenMobile,
          loop: false,
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewDesktop,
              spaceBetween: spaceBetweenDesktop
            }
          }
        });
        nextBtn.addEventListener('click', function() {
          swiper.slideNext();
        });
      }
      initSwiper();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSections);
  } else {
    initCustomSections();
  }

  // Re-initialize when section is re-rendered (theme customizer) so sliders and all features work
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      initCustomSections();
    }, 50);
  });

  // Collection load more: fetch next page and append products to grid
  document.addEventListener('click', function(e) {
    var btn = e.target && (e.target.closest ? e.target.closest('.collection-load-more__button') : null);
    if (!btn || btn.disabled) return;
    var wrapper = btn.closest('.collection-load-more');
    var grid = document.getElementById('product-grid');
    if (!wrapper || !grid) return;
    var sectionId = grid.dataset && grid.dataset.id;
    if (!sectionId) return;
    var totalPages = parseInt(wrapper.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = parseInt(wrapper.getAttribute('data-current-page'), 10) || 1;
    if (currentPage >= totalPages) return;
    var nextPage = currentPage + 1;
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(nextPage));
    var fetchUrl = window.location.pathname + '?section_id=' + sectionId + '&' + url.searchParams.toString();
    btn.classList.add('is-loading');
    btn.disabled = true;
    fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        if (nextGrid) {
          var items = nextGrid.querySelectorAll(':scope > li:not(.grid__item--full-width)');
          items.forEach(function(li) { grid.appendChild(li.cloneNode(true)); });
          if (typeof window.syncProductCardAvailableOptions === 'function') {
            window.syncProductCardAvailableOptions(grid);
          }
        }
        wrapper.setAttribute('data-current-page', String(nextPage));
        if (nextPage >= totalPages) {
          wrapper.classList.add('is-hidden');
        } else {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });

  // Scroll-to buttons (e.g. collection filter bar: data-scroll-to="#id" or ".class")
  document.addEventListener('click', function(e) {
    var btn = e.target && (e.target.closest ? e.target.closest('[data-scroll-to]') : null);
    if (!btn) return;
    var selector = btn.getAttribute('data-scroll-to');
    if (!selector) return;
    var el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // Erfahrungen page: scroll to contact form when URL hash is #Beraten-lassen
  function initErfahrungenBeratenLassenHashScroll() {
    function scrollToBeratenLassen() {
      if (window.location.hash.replace(/^#/, '') !== 'Beraten-lassen') return;
      var target = document.getElementById('Beraten-lassen');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        requestAnimationFrame(scrollToBeratenLassen);
      });
    } else {
      requestAnimationFrame(scrollToBeratenLassen);
    }

    window.addEventListener('hashchange', scrollToBeratenLassen);
  }
  initErfahrungenBeratenLassenHashScroll();

  // Collection filter bar: only show when product grid is in view (avoids flash on reload)
  function initCollectionFilterBarFade() {
    var grid = document.getElementById('ProductGridContainer');
    var bar = document.querySelector('.filters-stikcy-wrapper-bd-collection-page');
    if (!grid || !bar) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (!shouldSuppressCollectionFilterBar()) {
            bar.classList.add('filters-stikcy-wrapper-bd-collection-page--in-grid');
          }
        } else {
          bar.classList.remove('filters-stikcy-wrapper-bd-collection-page--in-grid');
        }
      });
    }, { root: null, rootMargin: '0px', threshold: 0 });
    observer.observe(grid);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilterBarFade);
  } else {
    initCollectionFilterBarFade();
  }
  
  // Split Content Image - Product Swatches
  function initSplitContentImageSwatches() {
    const sectionConfigs = [
      {
        sectionSelector: '.bd-split-content-image[data-section-id]',
        swiperIdPrefix: 'bd-split-content-image-swiper-',
        blockSelector: '.bd-split-content-image__block--product-swatches',
        swatchSelector: '.bd-split-content-image__swatch[data-slide-index]',
        swatchActiveClass: 'bd-split-content-image__swatch--active',
        swatchCheckClass: 'bd-split-content-image__swatch-check'
      },
      {
        sectionSelector: '.bd-texture-color[data-section-id]',
        swiperIdPrefix: 'bd-texture-color-swiper-',
        blockSelector: '.bd-texture-color__block--product-swatches',
        swatchSelector: '.bd-texture-color__swatch[data-slide-index]',
        swatchActiveClass: 'bd-texture-color__swatch--active',
        swatchCheckClass: 'bd-texture-color__swatch-check'
      }
    ];

    sectionConfigs.forEach(function(config) {
      const sections = document.querySelectorAll(config.sectionSelector);

      sections.forEach(function(section) {
        const sectionId = section.dataset.sectionId;
        const swiperElement = document.getElementById(config.swiperIdPrefix + sectionId);
        if (!swiperElement) return;
        
        const block = swiperElement.closest(config.blockSelector);
        if (!block) return;
      
      function initSwiper() {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(true, true);
        }
        const swiper = new Swiper(swiperElement, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: true,
        });

        // Handle color swatch clicks
        const swatches = block.querySelectorAll(config.swatchSelector);
        const slides = swiperElement.querySelectorAll('.swiper-slide');
        
        swatches.forEach(function(swatch) {
          swatch.addEventListener('click', function() {
            const slideIndex = parseInt(this.dataset.slideIndex);
            if (slideIndex >= 0 && slideIndex < slides.length) {
              swiper.slideTo(slideIndex);
              
              // Update active state
              swatches.forEach(function(s) {
                s.classList.remove(config.swatchActiveClass);
                const existingCheck = s.querySelector('.' + config.swatchCheckClass);
                if (existingCheck) existingCheck.remove();
              });
              this.classList.add(config.swatchActiveClass);
              
              // Add checkmark to active swatch
              if (!this.querySelector('.' + config.swatchCheckClass)) {
                const check = document.createElement('span');
                check.className = config.swatchCheckClass;
                check.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="#FDFCFB" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                this.appendChild(check);
              }
            }
          });
        });

        // Update active swatch when slide changes
        swiper.on('slideChange', function() {
          const activeIndex = swiper.activeIndex;
          const activeSlide = slides[activeIndex];
          if (activeSlide) {
            swatches.forEach(function(s) {
              const slideIndex = parseInt(s.dataset.slideIndex);
              
              s.classList.remove(config.swatchActiveClass);
              const existingCheck = s.querySelector('.' + config.swatchCheckClass);
              if (existingCheck) existingCheck.remove();
              
              if (slideIndex === activeIndex) {
                s.classList.add(config.swatchActiveClass);
                const check = document.createElement('span');
                check.className = config.swatchCheckClass;
                check.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6.00024L5.12132 8.12156L9.36351 3.87891" stroke="#FDFCFB" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                s.appendChild(check);
              }
            });
          }
        });
        }
        
        initSwiper();
      });
    });
  }

  function initCrossSell() {
    const addButtons = document.querySelectorAll('.bd-cart-crossell__add-btn');
    
    addButtons.forEach(button => {
      button.addEventListener('click', function() {
        const variantId = this.getAttribute('data-variant-id');
        const productTitle = this.getAttribute('data-product-title');
        
        if (!variantId) return;
        
        // Add loading state
        this.classList.add('loading');
        
        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(data => {
          console.log('[BD Cross-Sell] Added to cart:', data);
          
          this.classList.remove('loading');
          
          publish(PUB_SUB_EVENTS.cartUpdate, {
              cartData: data,
              variantId: variantId
          });
        })
        .catch(error => {
          console.error('[BD Cross-Sell] Error adding to cart:', error);
          this.classList.remove('loading');
          alert('Could not add product to cart. Please try again.');
        });
      });
    });
  }

  function initShippingModal() {
    const modal = document.getElementById('bd-shipping-modal');
    if (!modal) return;

    const openButtons = document.querySelectorAll('[data-open-shipping-modal]');
    const closeButtons = modal.querySelectorAll('[data-close-shipping-modal]');

    // Open modal
    openButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('cart-drawer').open();
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('bd-shipping-modal-open');
      });
    });

    // Close modal
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('bd-shipping-modal-open');
      });
    });

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('bd-shipping-modal-open');
      }
    });
  }

  // Collection hero title: shrink font so long titles stay on one line
  function fitCollectionHeroTitles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var titles = scope.querySelectorAll('.collection-hero__title[data-fit-one-line]');
    if (!titles.length) return;

    titles.forEach(function(title) {
      var measure = title.querySelector('.collection-hero__title-text') || title;
      title.style.fontSize = '';
      title.style.lineHeight = '';

      var computed = window.getComputedStyle(title);
      var maxPx = parseFloat(computed.fontSize);
      if (!maxPx || !isFinite(maxPx)) return;

      var lineHeightPx = parseFloat(computed.lineHeight);
      var lineHeightRatio = lineHeightPx && isFinite(lineHeightPx) ? lineHeightPx / maxPx : 1.05;
      var minPx = Math.max(window.matchMedia('(min-width: 990px)').matches ? 40 : 28, maxPx * 0.28);

      function applyTitleSize(fontSize) {
        title.style.fontSize = fontSize + 'px';
        title.style.lineHeight = (fontSize * lineHeightRatio) + 'px';
        title.style.setProperty(
          '--collection-title-mobile-offset',
          (-22 * Math.min(fontSize / maxPx, 1)) + 'px'
        );
      }

      title.style.whiteSpace = 'nowrap';
      measure.style.whiteSpace = 'nowrap';
      measure.style.display = 'block';
      measure.style.maxWidth = '100%';

      var available = title.clientWidth;
      if (!available) return;

      if (measure.scrollWidth <= available + 1) {
        applyTitleSize(maxPx);
        return;
      }

      var lo = minPx;
      var hi = maxPx;
      var best = minPx;

      while (hi - lo > 0.5) {
        var mid = (lo + hi) / 2;
        applyTitleSize(mid);
        if (measure.scrollWidth <= available + 1) {
          best = mid;
          lo = mid;
        } else {
          hi = mid;
        }
      }

      applyTitleSize(best);
    });
  }

  function initCollectionHeroTitleFit() {
    fitCollectionHeroTitles();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        fitCollectionHeroTitles();
      }, 100);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        fitCollectionHeroTitles();
      }).catch(function() {});
    }

    document.addEventListener('shopify:section:load', function(event) {
      fitCollectionHeroTitles(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionHeroTitleFit);
  } else {
    initCollectionHeroTitleFit();
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrossSell);
    document.addEventListener('DOMContentLoaded', initShippingModal);
  } else {
    initCrossSell();
    initShippingModal();
  }
  subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
    const cartsectionid = document.getElementById('main-cart-footer')?.dataset.id;
      if(cartsectionid){
      fetch(`${routes.cart_url}?section_id=${cartsectionid}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const footerSelector = '#main-cart-footer .bd-cart__info-section';
          const footerSelectorJS = '#main-cart-footer .js-contents2';
          const targetFooter = document.querySelector(footerSelector);
          const sourceFooter = html.querySelector(footerSelector);
          const targetFooterJS = document.querySelector(footerSelectorJS);
          const sourceFooterJS = html.querySelector(footerSelectorJS);
          
          if (targetFooter && sourceFooter) {
            targetFooter.replaceWith(sourceFooter);
          }
          if (targetFooterJS && sourceFooterJS) {
            targetFooterJS.replaceWith(sourceFooterJS);
          }
          setTimeout(function() {
            initCrossSell();
            initShippingModal();
          }, 1000);          
        })    
    } else {
      setTimeout(function() {
        initCrossSell();
        initShippingModal();
      }, 1000);      
    }
  });  
})();
